export const HomeIcon = props => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M24.5 20.7794V12.6773C24.5 11.5292 24.0013 10.4453 23.1488 9.74045L16.8651 4.54499C15.1799 3.15167 12.8201 3.15167 11.1349 4.54499L4.85121 9.74045C3.99865 10.4453 3.5 11.5292 3.5 12.6773V20.7794C3.5 22.8342 5.067 24.5 7 24.5H9.5C10.0523 24.5 10.5 24.0523 10.5 23.5V19.5391C10.5 17.4843 12.067 15.8185 14 15.8185C15.933 15.8185 17.5 17.4843 17.5 19.5391V23.5C17.5 24.0523 17.9477 24.5 18.5 24.5H21C22.933 24.5 24.5 22.8342 24.5 20.7794Z"
				stroke={props.color}
				strokeWidth="2.5"
			/>
		</svg>
	);
};

export const ResidentIcon = props => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1 6V22L8 18L16 22L23 18V2L16 6L8 2L1 6Z"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 2V18"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 6V22"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const NoteIcon = props => {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.3845 5.34403C19.8182 4.91029 20.4065 4.66663 21.0199 4.66663C21.3236 4.66663 21.6244 4.72645 21.905 4.84268C22.1856 4.9589 22.4405 5.12926 22.6553 5.34403C22.87 5.55879 23.0404 5.81375 23.1566 6.09435C23.2729 6.37495 23.3327 6.67569 23.3327 6.97941C23.3327 7.28313 23.2729 7.58388 23.1566 7.86448C23.0404 8.14508 22.87 8.40004 22.6553 8.6148L9.94105 21.329C9.34298 21.9271 8.5936 22.3514 7.77305 22.5565L4.66602 23.3333L5.44277 20.2263C5.64791 19.4057 6.0722 18.6563 6.67027 18.0583L19.3845 5.34403Z"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.332 8.16663L19.832 11.6666"
				stroke={props.color}
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M15.166 23.3334L23.3327 23.3334"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const PlanIcon = props => {
	return (
		<svg
			width="24"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.33333 3.5V7M8.16667 24.5H19.8333C22.4107 24.5 24.5 22.4107 24.5 19.8333V9.33333C24.5 6.756 22.4107 4.66667 19.8333 4.66667H8.16667C5.58934 4.66667 3.5 6.756 3.5 9.33333V19.8333C3.5 22.4107 5.58934 24.5 8.16667 24.5Z"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M18.666 3.5V7"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M17.5 12.8334L13.125 17.5L10.5 15.3788"
				stroke={props.color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const MapIcon = props => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1 6V22L8 18L16 22L23 18V2L16 6L8 2L1 6Z"
				stroke="#5D5D7F"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 2V18"
				stroke="#5D5D7F"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 6V22"
				stroke="#5D5D7F"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const ClipBoardIcon = props => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8 3V6M7 21H17C19.2091 21 21 19.2091 21 17V8C21 5.79086 19.2091 4 17 4H7C4.79086 4 3 5.79086 3 8V17C3 19.2091 4.79086 21 7 21Z"
				stroke="#5D5D7F"
				strokeWidth="1.6"
				strokeLinecap="round"
			/>
			<path
				d="M16 3V6"
				stroke="#5D5D7F"
				strokeWidth="1.6"
				strokeLinecap="round"
			/>
			<path
				d="M15 11L11.25 15L9 13.1818"
				stroke="#5D5D7F"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const BotHomeIcon = () => {
	return (
		<svg
			width="24"
			height="28"
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.04 1.43994C13.9806 1.43994 13.12 2.30057 13.12 3.35994C13.12 4.25244 13.735 4.99682 14.56 5.21244V6.71994H10.255C8.12875 6.71994 6.4 8.44869 6.4 10.5749V12.4799H4V18.2399H6.4V22.5599H23.68V18.2399H26.08V12.4799H23.68V10.5749C23.68 8.44869 21.9513 6.71994 19.825 6.71994H15.52V5.21244C16.3469 4.99682 16.96 4.25244 16.96 3.35994C16.96 2.30057 16.0994 1.43994 15.04 1.43994ZM15.04 2.39994C15.5688 2.39994 16 2.83119 16 3.35994C16 3.88869 15.5688 4.31994 15.04 4.31994C14.5113 4.31994 14.08 3.88869 14.08 3.35994C14.08 2.83119 14.5113 2.39994 15.04 2.39994ZM10.255 7.67994H19.825C21.4206 7.67994 22.72 8.97932 22.72 10.5749V21.5999H19.84V17.7599H10.24V21.5999H7.36V10.5749C7.36 8.97932 8.65937 7.67994 10.255 7.67994ZM11.92 10.5599C10.7294 10.5599 9.76 11.5293 9.76 12.7199C9.76 13.9106 10.7294 14.8799 11.92 14.8799C13.1106 14.8799 14.08 13.9106 14.08 12.7199C14.08 11.5293 13.1106 10.5599 11.92 10.5599ZM18.16 10.5599C16.9694 10.5599 16 11.5293 16 12.7199C16 13.9106 16.9694 14.8799 18.16 14.8799C19.3506 14.8799 20.32 13.9106 20.32 12.7199C20.32 11.5293 19.3506 10.5599 18.16 10.5599ZM11.92 11.5199C12.5819 11.5199 13.12 12.0581 13.12 12.7199C13.12 13.3818 12.5819 13.9199 11.92 13.9199C11.2581 13.9199 10.72 13.3818 10.72 12.7199C10.72 12.0581 11.2581 11.5199 11.92 11.5199ZM18.16 11.5199C18.8219 11.5199 19.36 12.0581 19.36 12.7199C19.36 13.3818 18.8219 13.9199 18.16 13.9199C17.4981 13.9199 16.96 13.3818 16.96 12.7199C16.96 12.0581 17.4981 11.5199 18.16 11.5199ZM4.96 13.4399H6.4V17.2799H4.96V13.4399ZM23.68 13.4399H25.12V17.2799H23.68V13.4399ZM11.2 18.7199H13.12V21.5999H11.2V18.7199ZM14.08 18.7199H16V21.5999H14.08V18.7199ZM16.96 18.7199H18.88V21.5999H16.96V18.7199Z"
				stroke="#5D5D7F"
				strokeWidth="1"
			/>
		</svg>
	);
};

export const StarIcon = props => {
	return (
		<svg
			width="22"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.2379 10.81L14.6689 12.504C14.4577 13.1479 14.0982 13.7331 13.6193 14.2125C13.1404 14.6919 12.5556 15.0521 11.9119 15.264L10.1989 15.833C10.141 15.8517 10.0905 15.8884 10.0547 15.9376C10.0189 15.9868 9.99963 16.0461 9.99963 16.107C9.99963 16.1679 10.0189 16.2272 10.0547 16.2764C10.0905 16.3256 10.141 16.3622 10.1989 16.381L11.9119 16.95C12.5496 17.162 13.1289 17.5199 13.6039 17.9952C14.0789 18.4706 14.4364 19.0502 14.6479 19.688L15.2159 21.403C15.2341 21.4614 15.2705 21.5125 15.3198 21.5488C15.3691 21.585 15.4287 21.6046 15.4899 21.6046C15.5511 21.6046 15.6107 21.585 15.66 21.5488C15.7093 21.5125 15.7457 21.4614 15.7639 21.403L16.3539 19.709C16.5657 19.0715 16.9232 18.4921 17.3979 18.0169C17.8727 17.5416 18.4517 17.1835 19.0889 16.971L20.8029 16.402C20.8608 16.3832 20.9113 16.3466 20.9471 16.2974C20.9829 16.2482 21.0022 16.1889 21.0022 16.128C21.0022 16.0671 20.9829 16.0078 20.9471 15.9586C20.9113 15.9094 20.8608 15.8727 20.8029 15.854L19.1109 15.264C18.467 15.0526 17.8819 14.6926 17.403 14.2131C16.924 13.7336 16.5646 13.1481 16.3539 12.504L15.7849 10.789C15.7689 10.7466 15.7432 10.7086 15.7098 10.678C15.6765 10.6474 15.6364 10.625 15.5928 10.6128C15.5492 10.6005 15.5033 10.5987 15.4589 10.6074C15.4144 10.6161 15.3727 10.6352 15.3369 10.663C15.2891 10.7006 15.2545 10.7514 15.2379 10.81ZM6.80793 5.89699L6.39493 7.12799C6.24122 7.59632 5.97959 8.02197 5.63114 8.37059C5.28269 8.71921 4.85718 8.98106 4.38893 9.13499L3.14293 9.54899C3.10127 9.56303 3.06508 9.58979 3.03943 9.62549C3.01379 9.66119 3 9.70404 3 9.74799C3 9.79195 3.01379 9.83479 3.03943 9.87049C3.06508 9.9062 3.10127 9.93295 3.14293 9.94699L4.38893 10.362C4.85258 10.516 5.27389 10.7761 5.61935 11.1216C5.96482 11.467 6.22491 11.8883 6.37893 12.352L6.79193 13.6C6.80596 13.6416 6.83272 13.6778 6.86842 13.7035C6.90412 13.7291 6.94697 13.7429 6.99093 13.7429C7.03488 13.7429 7.07773 13.7291 7.11343 13.7035C7.14913 13.6778 7.17589 13.6416 7.18993 13.6L7.61993 12.368C7.77429 11.9045 8.0345 11.4834 8.37992 11.138C8.72533 10.7926 9.14646 10.5324 9.60993 10.378L10.8549 9.96299C10.8966 9.94895 10.9328 9.9222 10.9584 9.88649C10.9841 9.85079 10.9979 9.80795 10.9979 9.76399C10.9979 9.72004 10.9841 9.67719 10.9584 9.64149C10.9328 9.60579 10.8966 9.57903 10.8549 9.56499L9.62493 9.13499C9.15671 8.98121 8.73124 8.7194 8.38293 8.37074C8.03462 8.02209 7.77324 7.59636 7.61993 7.12799L7.20592 5.88099C7.19029 5.83982 7.16211 5.8046 7.12536 5.78032C7.08862 5.75604 7.04517 5.74393 7.00117 5.7457C6.95716 5.74747 6.91482 5.76303 6.88015 5.79018C6.84547 5.81733 6.8202 5.85469 6.80793 5.89699ZM14.6569 2.47499L14.4499 3.09099C14.3733 3.32516 14.2427 3.53803 14.0686 3.71243C13.8946 3.88683 13.6819 4.01787 13.4479 4.09499L12.8249 4.30199C12.8093 4.30706 12.7951 4.31576 12.7835 4.32736C12.7719 4.33896 12.7632 4.35314 12.7582 4.36875C12.7531 4.38435 12.7518 4.40093 12.7544 4.41714C12.7569 4.43334 12.7633 4.44871 12.7729 4.46199C12.7856 4.48021 12.8039 4.49388 12.8249 4.50099L13.4479 4.70799C13.6798 4.785 13.8904 4.91504 14.0631 5.08778C14.2359 5.26051 14.3659 5.47117 14.4429 5.70299L14.6489 6.32699C14.6557 6.34818 14.6691 6.36667 14.687 6.37979C14.705 6.39291 14.7267 6.39997 14.7489 6.39997C14.7712 6.39997 14.7929 6.39291 14.8108 6.37979C14.8288 6.36667 14.8421 6.34818 14.8489 6.32699L15.0629 5.71099C15.1401 5.47928 15.2703 5.26873 15.443 5.09603C15.6157 4.92332 15.8262 4.79321 16.0579 4.71599L16.6809 4.50899C16.7021 4.50221 16.7206 4.48886 16.7337 4.47089C16.7468 4.45292 16.7539 4.43124 16.7539 4.40899C16.7539 4.38674 16.7468 4.36506 16.7337 4.34709C16.7206 4.32912 16.7021 4.31578 16.6809 4.30899L16.0659 4.09499C15.8317 4.01808 15.6188 3.88712 15.4446 3.7127C15.2704 3.53828 15.1396 3.32531 15.0629 3.09099L14.8559 2.46699C14.8481 2.4464 14.834 2.4288 14.8156 2.41666C14.7973 2.40452 14.7755 2.39846 14.7535 2.39935C14.7315 2.40023 14.7104 2.40801 14.693 2.42159C14.6757 2.43516 14.6631 2.45384 14.6569 2.47499Z"
				stroke={props.color}
				strokeWidth="1.3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const UploadIcon = () => {
	return (
		<svg
			width="72"
			height="72"
			viewBox="0 0 72 72"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M48 48L36 36L24 48"
				stroke="#28696D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M36 36V63"
				stroke="#28696D"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M61.1704 55.1699C64.0964 53.5748 66.4079 51.0506 67.74 47.9958C69.0721 44.9411 69.349 41.5296 68.527 38.3C67.705 35.0704 65.8308 32.2065 63.2004 30.1603C60.5699 28.1141 57.333 27.0022 54.0004 27H50.2204C49.3123 23.4877 47.6199 20.227 45.2702 17.4629C42.9206 14.6989 39.9749 12.5035 36.6547 11.0418C33.3344 9.58005 29.726 8.89003 26.1007 9.0236C22.4754 9.15717 18.9276 10.1109 15.7239 11.8129C12.5202 13.515 9.7441 15.9213 7.60424 18.8507C5.46437 21.7801 4.01644 25.1566 3.36931 28.7261C2.72218 32.2957 2.89268 35.9655 3.86801 39.4597C4.84333 42.9539 6.5981 46.1815 9.00037 48.8999"
				stroke="#28696D"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M48 48L36 36L24 48"
				stroke="#28696D"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const EnhanceIcon = () => {
	return (
		<svg
			width="22"
			height="22"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M21.7513 3C21.9503 3 22.141 3.07902 22.2817 3.21967C22.4223 3.36032 22.5013 3.55109 22.5013 3.75V5H23.7513C23.9503 5 24.141 5.07902 24.2817 5.21967C24.4223 5.36032 24.5013 5.55109 24.5013 5.75C24.5013 5.94891 24.4223 6.13968 24.2817 6.28033C24.141 6.42098 23.9503 6.5 23.7513 6.5H22.5013V7.75C22.5013 7.94891 22.4223 8.13968 22.2817 8.28033C22.141 8.42098 21.9503 8.5 21.7513 8.5C21.5524 8.5 21.3617 8.42098 21.221 8.28033C21.0804 8.13968 21.0013 7.94891 21.0013 7.75V6.5H19.7513C19.5524 6.5 19.3617 6.42098 19.221 6.28033C19.0804 6.13968 19.0013 5.94891 19.0013 5.75C19.0013 5.55109 19.0804 5.36032 19.221 5.21967C19.3617 5.07902 19.5524 5 19.7513 5H21.0013V3.75C21.0013 3.55109 21.0804 3.36032 21.221 3.21967C21.3617 3.07902 21.5524 3 21.7513 3ZM8.50134 6.25C8.50134 6.05109 8.42232 5.86032 8.28167 5.71967C8.14102 5.57902 7.95025 5.5 7.75134 5.5C7.55243 5.5 7.36166 5.57902 7.22101 5.71967C7.08036 5.86032 7.00134 6.05109 7.00134 6.25V7.5H5.75134C5.55243 7.5 5.36166 7.57902 5.22101 7.71967C5.08036 7.86032 5.00134 8.05109 5.00134 8.25C5.00134 8.44891 5.08036 8.63968 5.22101 8.78033C5.36166 8.92098 5.55243 9 5.75134 9H7.00134V10.25C7.00134 10.4489 7.08036 10.6397 7.22101 10.7803C7.36166 10.921 7.55243 11 7.75134 11C7.95025 11 8.14102 10.921 8.28167 10.7803C8.42232 10.6397 8.50134 10.4489 8.50134 10.25V9H9.75134C9.95025 9 10.141 8.92098 10.2817 8.78033C10.4223 8.63968 10.5013 8.44891 10.5013 8.25C10.5013 8.05109 10.4223 7.86032 10.2817 7.71967C10.141 7.57902 9.95025 7.5 9.75134 7.5H8.50134V6.25ZM20.5013 17.75C20.5013 17.5511 20.4223 17.3603 20.2817 17.2197C20.141 17.079 19.9503 17 19.7513 17C19.5524 17 19.3617 17.079 19.221 17.2197C19.0804 17.3603 19.0013 17.5511 19.0013 17.75V19H17.7513C17.5524 19 17.3617 19.079 17.221 19.2197C17.0804 19.3603 17.0013 19.5511 17.0013 19.75C17.0013 19.9489 17.0804 20.1397 17.221 20.2803C17.3617 20.421 17.5524 20.5 17.7513 20.5H19.0013V21.75C19.0013 21.9489 19.0804 22.1397 19.221 22.2803C19.3617 22.421 19.5524 22.5 19.7513 22.5C19.9503 22.5 20.141 22.421 20.2817 22.2803C20.4223 22.1397 20.5013 21.9489 20.5013 21.75V20.5H21.7513C21.9503 20.5 22.141 20.421 22.2817 20.2803C22.4223 20.1397 22.5013 19.9489 22.5013 19.75C22.5013 19.5511 22.4223 19.3603 22.2817 19.2197C22.141 19.079 21.9503 19 21.7513 19H20.5013V17.75ZM19.6353 9.478C19.419 9.09014 19.1157 8.75768 18.7493 8.50669C18.3829 8.25571 17.9633 8.09303 17.5234 8.03142C17.0836 7.9698 16.6355 8.01092 16.2142 8.15156C15.7929 8.2922 15.41 8.52852 15.0953 8.842L2.80734 21.088C2.26643 21.6274 1.96197 22.3597 1.96094 23.1236C1.95991 23.8875 2.26239 24.6206 2.80184 25.1615C3.34129 25.7024 4.07352 26.0069 4.83745 26.0079C5.60138 26.0089 6.33443 25.7064 6.87534 25.167L19.1543 12.913C19.5974 12.4708 19.884 11.896 19.9707 11.276C20.0573 10.6561 19.9392 10.0247 19.6343 9.478M16.1523 9.904C16.4111 9.64927 16.7601 9.50724 17.1232 9.5089C17.4863 9.51056 17.834 9.65578 18.0905 9.91286C18.3469 10.1699 18.4912 10.518 18.4919 10.8811C18.4927 11.2442 18.3497 11.5929 18.0943 11.851L17.2523 12.691L15.3073 10.746L16.1523 9.904ZM14.2453 11.806L16.1903 13.751L5.81634 24.105C5.68854 24.2352 5.53618 24.3389 5.36807 24.4098C5.19997 24.4808 5.01945 24.5177 4.83698 24.5185C4.65451 24.5192 4.4737 24.4838 4.30502 24.4142C4.13633 24.3446 3.98313 24.2422 3.85426 24.113C3.7254 23.9839 3.62344 23.8304 3.55428 23.6615C3.48512 23.4927 3.45013 23.3118 3.45135 23.1293C3.45257 22.9468 3.48996 22.7664 3.56136 22.5985C3.63277 22.4306 3.73677 22.2785 3.86734 22.151L14.2453 11.806Z"
				fill="white"
			/>
		</svg>
	);
};

export const SmallClipBoardIcon = () => {
	return (
		<svg
			width="23"
			height="24"
			viewBox="0 0 23 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.332 4.33337H17.2487C17.757 4.33337 18.2445 4.53531 18.604 4.89475C18.9634 5.2542 19.1654 5.74171 19.1654 6.25004V19.6667C19.1654 20.175 18.9634 20.6625 18.604 21.022C18.2445 21.3814 17.757 21.5834 17.2487 21.5834H5.7487C5.24037 21.5834 4.75285 21.3814 4.39341 21.022C4.03397 20.6625 3.83203 20.175 3.83203 19.6667V6.25004C3.83203 5.74171 4.03397 5.2542 4.39341 4.89475C4.75285 4.53531 5.24037 4.33337 5.7487 4.33337H7.66536"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.3763 2.41663H8.6263C8.09703 2.41663 7.66797 2.84569 7.66797 3.37496V5.29163C7.66797 5.8209 8.09703 6.24996 8.6263 6.24996H14.3763C14.9056 6.24996 15.3346 5.8209 15.3346 5.29163V3.37496C15.3346 2.84569 14.9056 2.41663 14.3763 2.41663Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const RefreshIcon = () => {
	return (
		<svg
			width="25"
			height="25"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_81_794)">
				<path
					d="M30.668 5.33337V13.3334H22.668"
					stroke="#28696D"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27.3185 20C26.4518 22.4532 24.8113 24.5583 22.6441 25.998C20.4769 27.4377 17.9005 28.134 15.3031 27.9821C12.7057 27.8301 10.2281 26.8381 8.24354 25.1555C6.25901 23.4729 4.8751 21.1909 4.30036 18.6534C3.72561 16.1158 3.99117 13.4602 5.05702 11.0867C6.12287 8.71324 7.93125 6.75046 10.2097 5.49416C12.4881 4.23786 15.1131 3.75611 17.6891 4.1215C20.2652 4.48689 22.6527 5.67963 24.4919 7.51998L30.6652 13.3333"
					stroke="#28696D"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_81_794">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const GenerateIcon = () => {
	return (
		<svg
			width="21"
			height="19"
			viewBox="0 0 21 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13 3.25C13.862 3.25 14.6886 2.90759 15.2981 2.2981C15.9076 1.6886 16.25 0.861954 16.25 0H17.75C17.75 0.861954 18.0924 1.6886 18.7019 2.2981C19.3114 2.90759 20.138 3.25 21 3.25V4.75C20.138 4.75 19.3114 5.09241 18.7019 5.7019C18.0924 6.3114 17.75 7.13805 17.75 8H16.25C16.25 7.13805 15.9076 6.3114 15.2981 5.7019C14.6886 5.09241 13.862 4.75 13 4.75V3.25ZM2 5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H11V1H4C2.93913 1 1.92172 1.42143 1.17157 2.17157C0.421427 2.92172 0 3.93913 0 5V15C0 16.0609 0.421427 17.0783 1.17157 17.8284C1.92172 18.5786 2.93913 19 4 19H16C17.0609 19 18.0783 18.5786 18.8284 17.8284C19.5786 17.0783 20 16.0609 20 15V10H18V15C18 15.5304 17.7893 16.0391 17.4142 16.4142C17.0391 16.7893 16.5304 17 16 17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15V5Z"
				fill="white"
			/>
		</svg>
	);
};

export const DownloadIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 8L10 13L15 8"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 13V1"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export function CloseIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6 6L18 18"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 6L6 18"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export const DropdownArrow = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
				fill="#F4F5F7"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.1471 14.5025C12.0162 14.635 11.8388 14.7094 11.6537 14.7094C11.4687 14.7094 11.2913 14.635 11.1604 14.5025L7.21303 10.505C7.14638 10.4398 7.09322 10.3618 7.05665 10.2756C7.02008 10.1894 7.00083 10.0967 7.00003 10.0028C6.99922 9.909 7.01688 9.81595 7.05196 9.72911C7.08705 9.64226 7.13886 9.56336 7.20438 9.49701C7.26989 9.43066 7.3478 9.37819 7.43356 9.34266C7.51931 9.30713 7.6112 9.28925 7.70385 9.29007C7.7965 9.29088 7.88806 9.31037 7.9732 9.34741C8.05833 9.38444 8.13533 9.43828 8.1997 9.50577L11.6537 13.0037L15.1078 9.50577C15.2394 9.37705 15.4156 9.30582 15.5986 9.30743C15.7816 9.30904 15.9566 9.38336 16.0859 9.51438C16.2153 9.6454 16.2887 9.82263 16.2903 10.0079C16.2919 10.1932 16.2216 10.3717 16.0944 10.505L12.1471 14.5025Z"
				fill="#5E5C5C"
			/>
		</svg>
	);
};

export const ConfigIcon = props => {
	return (
		<svg
			fill={props.color}
			height="23px"
			width="23px"
			id="Capa_1"
			viewBox="0 0 58 58"
			stroke={props.color}
			strokeWidth="2">
			<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				strokeLinecap="round"
				strokeLinejoin="round"></g>
			<g id="SVGRepo_iconCarrier">
				<g>
					<path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.42l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z"></path>{' '}
					<path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z"></path>{' '}
				</g>
			</g>
		</svg>
	);
};

export const CopyIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="20px"
			viewBox="0 -960 960 960"
			width="20px"
			fill="#28696D">
			<path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
		</svg>
	);
};

export const ConnectAPi = () => {
	return (
		<svg
			width="70"
			height="70"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect
				x="0.5"
				y="0.5"
				width="79"
				height="79"
				rx="19.5"
				fill="white"
			/>
			<rect
				x="0.5"
				y="0.5"
				width="79"
				height="79"
				rx="19.5"
				stroke="#D5DBE1"
			/>
			<path
				d="M30.0186 49.9827C33.368 53.1721 37.356 51.8961 38.952 50.6041C39.776 49.9361 40.148 49.5041 40.4666 49.1841C41.5826 48.1481 41.512 47.1107 40.7866 46.2814C40.4946 45.9494 38.632 44.1601 36.8453 42.3254C35.92 41.4001 35.2826 40.7467 34.736 40.2187C34.0066 39.4907 33.368 38.6561 32.4106 38.6801C31.5333 38.6801 30.896 39.4534 30.0973 40.2521C29.18 41.1694 28.5026 42.3254 28.264 43.3627C27.5453 46.3934 28.6626 48.5467 30.0186 49.9827ZM30.0186 49.9827L26.668 53.3321M49.984 30.0201C46.6333 26.8281 42.6586 28.1267 41.064 29.4201C40.2373 30.0894 39.8666 30.5214 39.5466 30.8414C38.4306 31.8787 38.5013 32.9161 39.228 33.7454C39.332 33.8654 39.6413 34.1721 40.0746 34.6041M49.984 30.0201C51.34 31.4561 52.472 33.6334 51.7533 36.6667C51.5133 37.7041 50.836 38.8601 49.9186 39.7787C49.1213 40.5761 48.4826 41.3507 47.6053 41.3507C46.648 41.3747 46.152 40.6814 45.42 39.9534M49.984 30.0201L53.3346 26.6667M40.0746 34.6041C40.8493 35.3707 42.0253 36.5267 43.1693 37.7027C44.0946 38.6281 44.8733 39.4254 45.42 39.9521L43.3373 41.9841M40.0746 34.6041L38.0173 36.6734"
				stroke="#87B6B3"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const UploadFile = () => {
	return (
		<svg
			width="70"
			height="70"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect
				x="0.5"
				y="0.5"
				width="79"
				height="79"
				rx="19.5"
				fill="white"
			/>
			<rect
				x="0.5"
				y="0.5"
				width="79"
				height="79"
				rx="19.5"
				stroke="#D5DBE1"
			/>
			<path
				d="M45.3346 45.3333L40.0013 40L34.668 45.3333"
				stroke="#87B6B3"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M40 40V52"
				stroke="#87B6B3"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M51.1886 48.5199C52.489 47.8109 53.5163 46.6891 54.1084 45.3314C54.7005 43.9737 54.8235 42.4575 54.4582 41.0221C54.0928 39.5868 53.2599 38.3139 52.0908 37.4045C50.9217 36.4951 49.4831 36.0009 48.0019 35.9999H46.3219C45.9183 34.4389 45.1661 32.9897 44.1218 31.7612C43.0775 30.5328 41.7684 29.557 40.2927 28.9074C38.817 28.2577 37.2133 27.951 35.6021 28.0104C33.9908 28.0698 32.414 28.4936 30.9901 29.2501C29.5663 30.0066 28.3324 31.076 27.3814 32.378C26.4303 33.68 25.7868 35.1806 25.4992 36.7671C25.2116 38.3536 25.2874 39.9846 25.7209 41.5376C26.1543 43.0906 26.9342 44.525 28.0019 45.7332"
				stroke="#87B6B3"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M45.3346 45.3333L40.0013 40L34.668 45.3333"
				stroke="#87B6B3"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const CircleClose = () => {
	return (
		<svg
			width="20"
			height="19"
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.04167 15.1666C4.08833 15.1666 0.875 11.9533 0.875 7.99992C0.875 4.04659 4.08833 0.833252 8.04167 0.833252C11.995 0.833252 15.2083 4.04659 15.2083 7.99992C15.2083 11.9533 11.995 15.1666 8.04167 15.1666ZM8.04167 1.83325C4.64167 1.83325 1.875 4.59992 1.875 7.99992C1.875 11.3999 4.64167 14.1666 8.04167 14.1666C11.4417 14.1666 14.2083 11.3999 14.2083 7.99992C14.2083 4.59992 11.4417 1.83325 8.04167 1.83325Z"
				fill="#292D32"
			/>
			<path
				d="M6.15458 10.3867C6.02792 10.3867 5.90125 10.34 5.80125 10.24C5.60792 10.0467 5.60792 9.72666 5.80125 9.53332L9.57458 5.75999C9.76792 5.56666 10.0879 5.56666 10.2812 5.75999C10.4746 5.95332 10.4746 6.27332 10.2812 6.46666L6.50792 10.24C6.41458 10.34 6.28125 10.3867 6.15458 10.3867Z"
				fill="#292D32"
			/>
			<path
				d="M9.92792 10.3867C9.80125 10.3867 9.67458 10.34 9.57458 10.24L5.80125 6.46666C5.60792 6.27332 5.60792 5.95332 5.80125 5.75999C5.99458 5.56666 6.31458 5.56666 6.50792 5.75999L10.2812 9.53332C10.4746 9.72666 10.4746 10.0467 10.2812 10.24C10.1812 10.34 10.0546 10.3867 9.92792 10.3867Z"
				fill="#292D32"
			/>
		</svg>
	);
};

export const GreenTickIcon = () => {
	return (
		<svg
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.04427 1.66675C3.8301 1.66675 1.21094 4.28591 1.21094 7.50008C1.21094 10.7142 3.8301 13.3334 7.04427 13.3334C10.2584 13.3334 12.8776 10.7142 12.8776 7.50008C12.8776 4.28591 10.2584 1.66675 7.04427 1.66675ZM9.8326 6.15841L6.5251 9.46591C6.44344 9.54758 6.3326 9.59425 6.21594 9.59425C6.09927 9.59425 5.98844 9.54758 5.90677 9.46591L4.25594 7.81508C4.08677 7.64591 4.08677 7.36591 4.25594 7.19675C4.4251 7.02758 4.7051 7.02758 4.87427 7.19675L6.21594 8.53841L9.21427 5.54008C9.38344 5.37091 9.66344 5.37091 9.8326 5.54008C10.0018 5.70925 10.0018 5.98341 9.8326 6.15841Z"
				fill="#28696D"
			/>
		</svg>
	);
};

export function DeleteIcon(props) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7 21C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99934 19.5493 5 19V6C4.71667 6 4.479 5.904 4.287 5.712C4.095 5.52 3.99934 5.28267 4 5C4 4.71667 4.096 4.479 4.288 4.287C4.48 4.095 4.71734 3.99934 5 4H9C9 3.71667 9.096 3.479 9.288 3.287C9.48 3.095 9.71734 2.99934 10 3H14C14.2833 3 14.521 3.096 14.713 3.288C14.905 3.48 15.0007 3.71734 15 4H19C19.2833 4 19.521 4.096 19.713 4.288C19.905 4.48 20.0007 4.71734 20 5C20 5.28334 19.904 5.521 19.712 5.713C19.52 5.905 19.2827 6.00067 19 6V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7ZM7 6V19H17V6H7ZM9 16C9 16.2833 9.096 16.521 9.288 16.713C9.48 16.905 9.71734 17.0007 10 17C10.2833 17 10.521 16.904 10.713 16.712C10.905 16.52 11.0007 16.2827 11 16V9C11 8.71667 10.904 8.479 10.712 8.287C10.52 8.095 10.2827 7.99934 10 8C9.71667 8 9.479 8.096 9.287 8.288C9.095 8.48 8.99934 8.71734 9 9V16ZM13 16C13 16.2833 13.096 16.521 13.288 16.713C13.48 16.905 13.7173 17.0007 14 17C14.2833 17 14.521 16.904 14.713 16.712C14.905 16.52 15.0007 16.2827 15 16V9C15 8.71667 14.904 8.479 14.712 8.287C14.52 8.095 14.2827 7.99934 14 8C13.7167 8 13.479 8.096 13.287 8.288C13.095 8.48 12.9993 8.71734 13 9V16Z"
				fill="#7F7F7F"
			/>
		</svg>
	);
}

export function EditIcon(props) {
	return (
		<svg
			width="19"
			height="19"
			viewBox="0 0 19 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.1665 1.5C14.3854 1.28113 14.6452 1.10752 14.9312 0.989064C15.2171 0.870613 15.5236 0.809647 15.8332 0.809647C16.1427 0.809647 16.4492 0.870613 16.7352 0.989064C17.0211 1.10752 17.281 1.28113 17.4998 1.5C17.7187 1.71887 17.8923 1.97871 18.0108 2.26468C18.1292 2.55064 18.1902 2.85714 18.1902 3.16667C18.1902 3.4762 18.1292 3.7827 18.0108 4.06866C17.8923 4.35463 17.7187 4.61447 17.4998 4.83334L6.24984 16.0833L1.6665 17.3333L2.9165 12.75L14.1665 1.5Z"
				stroke="black"
				strokeOpacity="0.5"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function ViewIcon(props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_792_6316)">
				<path
					d="M0.833252 9.99999C0.833252 9.99999 4.16659 3.33333 9.99992 3.33333C15.8333 3.33333 19.1666 9.99999 19.1666 9.99999C19.1666 9.99999 15.8333 16.6667 9.99992 16.6667C4.16659 16.6667 0.833252 9.99999 0.833252 9.99999Z"
					stroke="#7D7D7D"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
					stroke="#7D7D7D"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_792_6316">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function LogoutIcon(props) {
	return (
		<svg
			width="20"
			height="21"
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.19107 13.0006C9.65098 12.9832 10.0379 13.342 10.0552 13.8019C10.0944 14.8387 10.1494 15.5955 10.2034 16.138C10.2566 16.6724 10.5792 16.9939 11.0289 17.0488C11.5591 17.1136 12.307 17.1667 13.3334 17.1667C14.3598 17.1667 15.1078 17.1136 15.638 17.0488C16.0874 16.9939 16.4101 16.6722 16.4634 16.1378C16.5637 15.1307 16.6667 13.3907 16.6667 10.5C16.6667 7.60933 16.5637 5.86935 16.4634 4.86224C16.4101 4.32778 16.0874 4.00615 15.638 3.95121C15.1078 3.88639 14.3598 3.83334 13.3334 3.83334C12.307 3.83334 11.5591 3.88639 11.0289 3.9512C10.5792 4.00617 10.2566 4.32766 10.2034 4.86199C10.1494 5.40455 10.0944 6.16129 10.0552 7.19811C10.0379 7.65802 9.65098 8.01678 9.19107 7.99942C8.73116 7.98205 8.3724 7.59515 8.38976 7.13524C8.42994 6.07104 8.4869 5.27953 8.54495 4.69677C8.667 3.47163 9.52117 2.45643 10.8266 2.29685C11.4343 2.22256 12.2507 2.16668 13.3334 2.16668C14.4161 2.16668 15.2325 2.22257 15.8402 2.29686C17.1458 2.45646 17.9998 3.47213 18.1218 4.69703C18.2293 5.77558 18.3334 7.57374 18.3334 10.5C18.3334 13.4263 18.2293 15.2244 18.1218 16.303C17.9998 17.5279 17.1458 18.5436 15.8402 18.7032C15.2325 18.7775 14.4161 18.8333 13.3334 18.8333C12.2507 18.8333 11.4343 18.7775 10.8266 18.7032C9.52117 18.5436 8.667 17.5284 8.54495 16.3032C8.4869 15.7205 8.42994 14.929 8.38976 13.8648C8.3724 13.4049 8.73116 13.018 9.19107 13.0006Z"
				fill={props.color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.00576 12.8274C6.3312 13.1528 6.3312 13.6805 6.00576 14.0059C5.68032 14.3314 5.15269 14.3314 4.82725 14.0059L1.91058 11.0893C1.58514 10.7638 1.58514 10.2362 1.91058 9.91074L4.82725 6.99408C5.15269 6.66864 5.68032 6.66864 6.00576 6.99408C6.3312 7.31951 6.3312 7.84715 6.00576 8.17259L4.51168 9.66667H12.4998C12.9601 9.66667 13.3332 10.0398 13.3332 10.5C13.3332 10.9602 12.9601 11.3333 12.4998 11.3333L4.51168 11.3333L6.00576 12.8274Z"
				fill={props.color}
			/>
		</svg>
	);
}

export const UserIcon = props => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 14 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 17.5C0 15.7319 0.67945 14.0362 1.88888 12.786C3.09831 11.5357 4.73865 10.8333 6.44904 10.8333C8.15943 10.8333 9.79976 11.5357 11.0092 12.786C12.2186 14.0362 12.8981 15.7319 12.8981 17.5H0ZM7.25517 12.5692V15.8333H11.0109C10.7228 14.9928 10.2227 14.2471 9.56243 13.6733C8.90216 13.0994 8.10563 12.7183 7.25517 12.5692ZM5.64291 15.8333V12.5692C4.79244 12.7183 3.99591 13.0994 3.33564 13.6733C2.67538 14.2471 2.17532 14.9928 1.88715 15.8333H5.64291ZM6.44904 10C3.77672 10 1.61226 7.7625 1.61226 5C1.61226 2.2375 3.77672 0 6.44904 0C9.12136 0 11.2858 2.2375 11.2858 5C11.2858 7.7625 9.12136 10 6.44904 10ZM6.44904 8.33333C8.23058 8.33333 9.67355 6.84167 9.67355 5C9.67355 3.15833 8.23058 1.66667 6.44904 1.66667C4.66749 1.66667 3.22452 3.15833 3.22452 5C3.22452 6.84167 4.66749 8.33333 6.44904 8.33333Z"
				fill={props.color}
			/>
		</svg>
	);
};

export const EyeIcon = props => {
	return (
		<svg
			width="16"
			height="13"
			viewBox="0 0 20 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.9165 8.1C17.8972 3.41 14.0986 0.5 10 0.5C5.90143 0.5 2.10275 3.41 0.0834557 8.1C0.0284116 8.22617 0 8.36234 0 8.5C0 8.63766 0.0284116 8.77383 0.0834557 8.9C2.10275 13.59 5.90143 16.5 10 16.5C14.0986 16.5 17.8972 13.59 19.9165 8.9C19.9716 8.77383 20 8.63766 20 8.5C20 8.36234 19.9716 8.22617 19.9165 8.1ZM10 14.5C6.8311 14.5 3.83215 12.21 2.10275 8.5C3.83215 4.79 6.8311 2.5 10 2.5C13.1689 2.5 16.1679 4.79 17.8972 8.5C16.1679 12.21 13.1689 14.5 10 14.5ZM10 4.5C9.20915 4.5 8.43606 4.7346 7.77849 5.17412C7.12093 5.61365 6.60841 6.23836 6.30577 6.96927C6.00312 7.70017 5.92394 8.50444 6.07823 9.28036C6.23251 10.0563 6.61334 10.769 7.17256 11.3284C7.73177 11.8878 8.44426 12.2688 9.21991 12.4231C9.99556 12.5775 10.7996 12.4983 11.5302 12.1955C12.2609 11.8928 12.8853 11.3801 13.3247 10.7223C13.7641 10.0645 13.9986 9.29113 13.9986 8.5C13.9986 7.43913 13.5773 6.42172 12.8274 5.67157C12.0776 4.92143 11.0605 4.5 10 4.5ZM10 10.5C9.60458 10.5 9.21803 10.3827 8.88925 10.1629C8.56046 9.94318 8.30421 9.63082 8.15288 9.26537C8.00156 8.89991 7.96197 8.49778 8.03911 8.10982C8.11626 7.72186 8.30667 7.36549 8.58628 7.08579C8.86589 6.80608 9.22213 6.6156 9.60996 6.53843C9.99778 6.46126 10.3998 6.50087 10.7651 6.65224C11.1304 6.80362 11.4427 7.05996 11.6624 7.38886C11.882 7.71776 11.9993 8.10444 11.9993 8.5C11.9993 9.03043 11.7887 9.53914 11.4137 9.91421C11.0388 10.2893 10.5302 10.5 10 10.5Z"
				fill={props.error ? 'red' : '#777E91'}
			/>
		</svg>
	);
};

export const HideEyeIcon = props => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.60623 6.08071C1.72698 6.02901 1.85673 6.00161 1.98807 6.00007C2.11941 5.99853 2.24976 6.02287 2.37169 6.07172C2.49362 6.12056 2.60473 6.19295 2.69868 6.28475C2.79263 6.37654 2.86757 6.48595 2.91923 6.60671L2.00023 7.00071L2.92023 6.60671L2.92323 6.61471L2.94423 6.65971C2.96423 6.70171 2.99523 6.76771 3.03823 6.85371C3.12423 7.02571 3.25723 7.27771 3.43823 7.58271C3.91531 8.38461 4.47503 9.13436 5.10823 9.81971C5.29794 10.0239 5.49473 10.2213 5.69823 10.4117C7.18023 11.8007 9.25123 13.0007 12.0002 13.0007C13.102 13.0056 14.1947 12.8013 15.2202 12.3987C16.4472 11.9157 17.4742 11.1887 18.3162 10.4007C19.4415 9.33143 20.367 8.07001 21.0492 6.67571L21.0762 6.61771L21.0812 6.60671C21.1882 6.36672 21.3853 6.17847 21.63 6.08266C21.8746 5.98685 22.1472 5.99118 22.3887 6.09471C22.6301 6.19825 22.8212 6.39267 22.9205 6.63593C23.0198 6.8792 23.0193 7.15177 22.9192 7.39471L22.9172 7.39971L22.9132 7.40771L22.9022 7.43371L22.8622 7.52071C22.64 7.98324 22.3927 8.43325 22.1212 8.86871C21.6215 9.67176 21.0488 10.427 20.4102 11.1247L21.2072 11.9217C21.3949 12.1092 21.5003 12.3636 21.5004 12.6289C21.5005 12.8941 21.3952 13.1486 21.2077 13.3362C21.0202 13.5239 20.7659 13.6293 20.5006 13.6294C20.2353 13.6295 19.9809 13.5242 19.7932 13.3367L18.9532 12.4967C18.3628 12.9755 17.7275 13.3961 17.0562 13.7527L17.8382 14.9547C17.912 15.0647 17.9632 15.1883 17.9888 15.3183C18.0144 15.4483 18.0139 15.582 17.9874 15.7118C17.9609 15.8416 17.9089 15.9648 17.8343 16.0743C17.7598 16.1838 17.6642 16.2774 17.5532 16.3497C17.4422 16.422 17.3179 16.4715 17.1876 16.4953C17.0573 16.5191 16.9236 16.5169 16.7942 16.4886C16.6647 16.4603 16.5422 16.4066 16.4338 16.3306C16.3253 16.2545 16.233 16.1577 16.1622 16.0457L15.1762 14.5317C14.4972 14.7397 13.7722 14.8867 13.0002 14.9557V16.5007C13.0002 16.7659 12.8949 17.0203 12.7073 17.2078C12.5198 17.3954 12.2654 17.5007 12.0002 17.5007C11.735 17.5007 11.4807 17.3954 11.2931 17.2078C11.1056 17.0203 11.0002 16.7659 11.0002 16.5007V14.9567C10.2252 14.8867 9.50023 14.7397 8.82323 14.5317L7.83823 16.0457C7.69033 16.2602 7.46457 16.4085 7.20898 16.459C6.9534 16.5096 6.68818 16.4584 6.46977 16.3164C6.25136 16.1743 6.09701 15.9526 6.03958 15.6985C5.98214 15.4444 6.02614 15.1779 6.16223 14.9557L6.94423 13.7527C6.24423 13.3827 5.61223 12.9527 5.04723 12.4957L4.20723 13.3357C4.01863 13.5179 3.76602 13.6187 3.50383 13.6164C3.24163 13.6141 2.99082 13.5089 2.80541 13.3235C2.62 13.1381 2.51483 12.8873 2.51256 12.6251C2.51028 12.3629 2.61107 12.1103 2.79323 11.9217L3.59023 11.1247C2.8828 10.3509 2.25622 9.50682 1.72023 8.60571C1.50612 8.2461 1.30891 7.8767 1.12923 7.49871C1.11805 7.47479 1.10705 7.45079 1.09623 7.42671L1.08623 7.40571L1.08423 7.39871L1.08323 7.39671C1.08023 7.39671 1.08023 7.39471 2.00023 7.00071L1.08123 7.39571C1.02935 7.27497 1.00177 7.14519 1.00008 7.01378C0.998392 6.88238 1.02262 6.75193 1.07138 6.6299C1.12014 6.50786 1.19247 6.39663 1.28424 6.30257C1.37602 6.20851 1.48543 6.13246 1.60623 6.08071Z"
				fill={props.error ? 'red' : '#777E91'}
			/>
		</svg>
	);
};

export const MainBotIcon = props => {
	return (
		<svg
			width="24"
			height="28"
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.04 1.43994C13.9806 1.43994 13.12 2.30057 13.12 3.35994C13.12 4.25244 13.735 4.99682 14.56 5.21244V6.71994H10.255C8.12875 6.71994 6.4 8.44869 6.4 10.5749V12.4799H4V18.2399H6.4V22.5599H23.68V18.2399H26.08V12.4799H23.68V10.5749C23.68 8.44869 21.9513 6.71994 19.825 6.71994H15.52V5.21244C16.3469 4.99682 16.96 4.25244 16.96 3.35994C16.96 2.30057 16.0994 1.43994 15.04 1.43994ZM15.04 2.39994C15.5688 2.39994 16 2.83119 16 3.35994C16 3.88869 15.5688 4.31994 15.04 4.31994C14.5113 4.31994 14.08 3.88869 14.08 3.35994C14.08 2.83119 14.5113 2.39994 15.04 2.39994ZM10.255 7.67994H19.825C21.4206 7.67994 22.72 8.97932 22.72 10.5749V21.5999H19.84V17.7599H10.24V21.5999H7.36V10.5749C7.36 8.97932 8.65937 7.67994 10.255 7.67994ZM11.92 10.5599C10.7294 10.5599 9.76 11.5293 9.76 12.7199C9.76 13.9106 10.7294 14.8799 11.92 14.8799C13.1106 14.8799 14.08 13.9106 14.08 12.7199C14.08 11.5293 13.1106 10.5599 11.92 10.5599ZM18.16 10.5599C16.9694 10.5599 16 11.5293 16 12.7199C16 13.9106 16.9694 14.8799 18.16 14.8799C19.3506 14.8799 20.32 13.9106 20.32 12.7199C20.32 11.5293 19.3506 10.5599 18.16 10.5599ZM11.92 11.5199C12.5819 11.5199 13.12 12.0581 13.12 12.7199C13.12 13.3818 12.5819 13.9199 11.92 13.9199C11.2581 13.9199 10.72 13.3818 10.72 12.7199C10.72 12.0581 11.2581 11.5199 11.92 11.5199ZM18.16 11.5199C18.8219 11.5199 19.36 12.0581 19.36 12.7199C19.36 13.3818 18.8219 13.9199 18.16 13.9199C17.4981 13.9199 16.96 13.3818 16.96 12.7199C16.96 12.0581 17.4981 11.5199 18.16 11.5199ZM4.96 13.4399H6.4V17.2799H4.96V13.4399ZM23.68 13.4399H25.12V17.2799H23.68V13.4399ZM11.2 18.7199H13.12V21.5999H11.2V18.7199ZM14.08 18.7199H16V21.5999H14.08V18.7199ZM16.96 18.7199H18.88V21.5999H16.96V18.7199Z"
				stroke={props.color}
				strokeWidth="1"
			/>
		</svg>
	);
};

export const ChatBotIcon = () => {
	return (
		<svg
			width="44"
			height="44"
			viewBox="0 0 44 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="22" cy="22" r="22" fill="#F2F8FF" />
			<path
				d="M22.0009 11.4399C20.9416 11.4399 20.0809 12.3006 20.0809 13.3599C20.0809 14.2524 20.6959 14.9968 21.5209 15.2124V16.7199H17.2159C15.0897 16.7199 13.3609 18.4487 13.3609 20.5749V22.4799H10.9609V28.2399H13.3609V32.5599H30.6409V28.2399H33.0409V22.4799H30.6409V20.5749C30.6409 18.4487 28.9122 16.7199 26.7859 16.7199H22.4809V15.2124C23.3078 14.9968 23.9209 14.2524 23.9209 13.3599C23.9209 12.3006 23.0603 11.4399 22.0009 11.4399ZM22.0009 12.3999C22.5297 12.3999 22.9609 12.8312 22.9609 13.3599C22.9609 13.8887 22.5297 14.3199 22.0009 14.3199C21.4722 14.3199 21.0409 13.8887 21.0409 13.3599C21.0409 12.8312 21.4722 12.3999 22.0009 12.3999ZM17.2159 17.6799H26.7859C28.3816 17.6799 29.6809 18.9793 29.6809 20.5749V31.5999H26.8009V27.7599H17.2009V31.5999H14.3209V20.5749C14.3209 18.9793 15.6203 17.6799 17.2159 17.6799ZM18.8809 20.5599C17.6903 20.5599 16.7209 21.5293 16.7209 22.7199C16.7209 23.9106 17.6903 24.8799 18.8809 24.8799C20.0716 24.8799 21.0409 23.9106 21.0409 22.7199C21.0409 21.5293 20.0716 20.5599 18.8809 20.5599ZM25.1209 20.5599C23.9303 20.5599 22.9609 21.5293 22.9609 22.7199C22.9609 23.9106 23.9303 24.8799 25.1209 24.8799C26.3116 24.8799 27.2809 23.9106 27.2809 22.7199C27.2809 21.5293 26.3116 20.5599 25.1209 20.5599ZM18.8809 21.5199C19.5428 21.5199 20.0809 22.0581 20.0809 22.7199C20.0809 23.3818 19.5428 23.9199 18.8809 23.9199C18.2191 23.9199 17.6809 23.3818 17.6809 22.7199C17.6809 22.0581 18.2191 21.5199 18.8809 21.5199ZM25.1209 21.5199C25.7828 21.5199 26.3209 22.0581 26.3209 22.7199C26.3209 23.3818 25.7828 23.9199 25.1209 23.9199C24.4591 23.9199 23.9209 23.3818 23.9209 22.7199C23.9209 22.0581 24.4591 21.5199 25.1209 21.5199ZM11.9209 23.4399H13.3609V27.2799H11.9209V23.4399ZM30.6409 23.4399H32.0809V27.2799H30.6409V23.4399ZM18.1609 28.7199H20.0809V31.5999H18.1609V28.7199ZM21.0409 28.7199H22.9609V31.5999H21.0409V28.7199ZM23.9209 28.7199H25.8409V31.5999H23.9209V28.7199Z"
				fill="#28696D"
			/>
		</svg>
	);
};

export const NewChatIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const InputImage = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M21 16.4407V12V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H13.5977"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 15L16 10L5 21"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<g clipPath="url(#clip0_3622_24262)">
				<path
					d="M18.5977 17.8989V21.9823"
					stroke="#28696D"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.5547 19.9407H20.638"
					stroke="#28696D"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3622_24262">
					<rect
						width="7"
						height="7"
						fill="white"
						transform="translate(15.0977 16.4407)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const SendChatIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.86018 3.87735L14.9364 7.2499C18.1108 8.76282 18.1108 11.2371 14.9364 12.75L7.86018 16.1226C3.09858 18.3919 1.15591 16.5323 3.53671 12.0014L4.25591 10.6382C4.43778 10.2915 4.43778 9.71628 4.25591 9.36957L3.53671 7.99848C1.15591 3.4676 3.10684 1.60796 7.86018 3.87735Z"
				stroke="#28696D"
				strokeWidth="1.24"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.49609 10H8.96009"
				stroke="#28696D"
				strokeWidth="1.24"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const SendLinkIcon = () => {
	return (
		<svg
			width="16"
			height="18"
			viewBox="0 0 16 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.50768 2.08999C7.86186 -0.163462 11.6683 -0.163462 14.0225 2.08999C16.3915 4.35762 16.3915 8.04548 14.0225 10.3131L7.66404 16.3995C5.99199 18 3.29147 18 1.61942 16.3995C-0.0674274 14.7848 -0.0674286 12.1556 1.61942 10.5409L7.88638 4.54207C8.87631 3.5945 10.4709 3.5945 11.4608 4.54207C12.4655 5.50382 12.4655 7.07443 11.4608 8.03617L5.14811 14.0788C4.90873 14.3079 4.52892 14.2996 4.29979 14.0603C4.07065 13.8209 4.07895 13.4411 4.31833 13.2119L10.631 7.1693C11.1421 6.68007 11.1421 5.89818 10.631 5.40894C10.1051 4.90554 9.24206 4.90554 8.71616 5.40894L2.4492 11.4078C1.25598 12.55 1.25598 14.3905 2.4492 15.5326C3.65723 16.689 5.62624 16.689 6.83426 15.5326L13.1927 9.44623C15.0681 7.65112 15.0681 4.75198 13.1927 2.95686C11.3026 1.14758 8.22761 1.14758 6.33746 2.95686L1.21411 7.86102C0.974731 8.09016 0.594923 8.08186 0.365785 7.84248C0.136647 7.6031 0.144949 7.22329 0.384329 6.99415L5.50768 2.08999Z"
				fill="#28696D"
			/>
		</svg>
	);
};

export const RecentChatIcon = () => {
	return (
		<svg
			width="18"
			height="20"
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.62569 1.36804C8.62569 0.888628 8.24612 0.5 7.7779 0.5C7.3096 0.5 6.93003 0.888628 6.93003 1.36804V3.24312H2.95539C1.59932 3.24312 0.5 4.36861 0.5 5.75698V13.4375C0.5 14.8259 1.59931 15.9514 2.95539 15.9514H6.54799C7.01622 15.9514 7.39578 15.5628 7.39578 15.0833C7.39578 14.604 7.01622 14.2153 6.54799 14.2153H2.95539C2.53582 14.2153 2.19568 13.8671 2.19568 13.4375V5.75698C2.19568 5.32742 2.53582 4.97918 2.95539 4.97918H12.6007C13.0202 4.97918 13.3604 5.32742 13.3604 5.75698V8.00085C13.3604 8.48023 13.74 8.86884 14.2082 8.86884C14.6764 8.86884 15.0561 8.48023 15.0561 8.00085V5.75698C15.0561 4.36861 13.9568 3.24312 12.6007 3.24312H8.62569V1.36804ZM5.20122 7.22557C5.66947 7.22557 6.04906 7.61418 6.04906 8.09356V9.19606C6.04906 9.67551 5.66947 10.0641 5.20122 10.0641C4.73297 10.0641 4.35338 9.67551 4.35338 9.19606V8.09356C4.35338 7.61418 4.73297 7.22557 5.20122 7.22557ZM11.2024 8.09356C11.2024 7.61418 10.8228 7.22557 10.3545 7.22557C9.88626 7.22557 9.50669 7.61418 9.50669 8.09356V9.19606C9.50669 9.67551 9.88626 10.0641 10.3545 10.0641C10.8228 10.0641 11.2024 9.67551 11.2024 9.19606V8.09356ZM9.77435 11.0423C9.96983 11.4779 9.78343 11.9933 9.35793 12.1934L9.35619 12.1943L9.3543 12.1951L9.35001 12.1971L9.33933 12.2019C9.33235 12.2051 9.324 12.2088 9.31426 12.2129L9.3099 12.2148C9.28672 12.2247 9.25648 12.2371 9.21964 12.2511C9.14609 12.2791 9.04544 12.3138 8.92197 12.3476C8.67656 12.415 8.3318 12.4818 7.9252 12.4818C7.50421 12.4818 7.15597 12.4162 6.90641 12.3475C6.78134 12.313 6.68004 12.2775 6.60547 12.2484C6.56819 12.2339 6.53745 12.2209 6.51354 12.2103C6.4969 12.2029 6.48026 12.1953 6.46384 12.1873L6.46289 12.1868C6.041 11.9789 5.86363 11.4601 6.06673 11.0282C6.26813 10.5998 6.76804 10.4177 7.18772 10.6174C7.19063 10.6186 7.1979 10.6218 7.20938 10.6262C7.23532 10.6363 7.28205 10.6532 7.34688 10.671C7.47703 10.7069 7.67608 10.7458 7.9252 10.7458C8.15259 10.7458 8.34728 10.7081 8.48267 10.6709C8.48674 10.6698 8.64684 10.633 8.6573 10.6125L9.77435 11.0423ZM8.6573 10.6125L9.77435 11.0423C9.58009 10.6093 9.08113 10.4184 8.6573 10.6125ZM15.6016 12.1856C15.3314 11.9089 14.8932 11.9089 14.623 12.1856L14.4928 12.319C14.5372 12.8489 14.9538 13.2753 15.4716 13.3207L15.6016 13.1875C15.8718 12.9108 15.8718 12.4623 15.6016 12.1856ZM11.6934 15.185L13.1777 13.6654C13.4163 14.0773 13.754 14.4229 14.1563 14.6673L12.672 16.1869C12.2576 16.6112 12.1145 16.754 11.9596 16.868C11.8106 16.9776 11.6505 17.0705 11.4821 17.1448C11.3068 17.2222 11.1136 17.2743 10.545 17.4199L10.4705 17.4389L10.4891 17.3626C10.6312 16.7805 10.6822 16.5827 10.7577 16.4033C10.8304 16.2308 10.921 16.0669 11.0282 15.9144C11.1395 15.7558 11.279 15.6093 11.6934 15.185ZM13.4239 10.9581C14.3564 10.0034 15.8682 10.0034 16.8007 10.9581C17.7331 11.9127 17.7331 13.4605 16.8007 14.4151L13.871 17.4145L13.8255 17.4612C13.4736 17.8216 13.2298 18.0712 12.9493 18.2777C12.7011 18.4604 12.4342 18.6151 12.1535 18.739C11.8362 18.8791 11.5017 18.9646 11.0189 19.0881L10.9563 19.1041L9.51084 19.4741C9.22196 19.548 8.91631 19.4613 8.7057 19.2457C8.4951 19.0301 8.41051 18.7172 8.48267 18.4214L8.84407 16.9415L8.85969 16.8776C8.98033 16.3831 9.06383 16.0407 9.20067 15.7159C9.32174 15.4284 9.47283 15.1553 9.65124 14.901C9.8529 14.6138 10.0968 14.3643 10.4487 14.004L10.4944 13.9574L13.4239 10.9581Z"
				fill="#98A2B3"
			/>
		</svg>
	);
};

export const ChatBotBubbleIcon = () => {
	return (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="16.5" cy="16" r="16" fill="#F2F8FF" />
			<path
				d="M16.5006 8.95996C15.7944 8.95996 15.2206 9.53371 15.2206 10.24C15.2206 10.835 15.6306 11.3312 16.1806 11.475V12.48H13.3106C11.8931 12.48 10.7406 13.6325 10.7406 15.05V16.32H9.14062V20.16H10.7406V23.04H22.2606V20.16H23.8606V16.32H22.2606V15.05C22.2606 13.6325 21.1081 12.48 19.6906 12.48H16.8206V11.475C17.3719 11.3312 17.7806 10.835 17.7806 10.24C17.7806 9.53371 17.2069 8.95996 16.5006 8.95996ZM16.5006 9.59996C16.8531 9.59996 17.1406 9.88746 17.1406 10.24C17.1406 10.5925 16.8531 10.88 16.5006 10.88C16.1481 10.88 15.8606 10.5925 15.8606 10.24C15.8606 9.88746 16.1481 9.59996 16.5006 9.59996ZM13.3106 13.12H19.6906C20.7544 13.12 21.6206 13.9862 21.6206 15.05V22.4H19.7006V19.84H13.3006V22.4H11.3806V15.05C11.3806 13.9862 12.2469 13.12 13.3106 13.12ZM14.4206 15.04C13.6269 15.04 12.9806 15.6862 12.9806 16.48C12.9806 17.2737 13.6269 17.92 14.4206 17.92C15.2144 17.92 15.8606 17.2737 15.8606 16.48C15.8606 15.6862 15.2144 15.04 14.4206 15.04ZM18.5806 15.04C17.7869 15.04 17.1406 15.6862 17.1406 16.48C17.1406 17.2737 17.7869 17.92 18.5806 17.92C19.3744 17.92 20.0206 17.2737 20.0206 16.48C20.0206 15.6862 19.3744 15.04 18.5806 15.04ZM14.4206 15.68C14.8619 15.68 15.2206 16.0387 15.2206 16.48C15.2206 16.9212 14.8619 17.28 14.4206 17.28C13.9794 17.28 13.6206 16.9212 13.6206 16.48C13.6206 16.0387 13.9794 15.68 14.4206 15.68ZM18.5806 15.68C19.0219 15.68 19.3806 16.0387 19.3806 16.48C19.3806 16.9212 19.0219 17.28 18.5806 17.28C18.1394 17.28 17.7806 16.9212 17.7806 16.48C17.7806 16.0387 18.1394 15.68 18.5806 15.68ZM9.78062 16.96H10.7406V19.52H9.78062V16.96ZM22.2606 16.96H23.2206V19.52H22.2606V16.96ZM13.9406 20.48H15.2206V22.4H13.9406V20.48ZM15.8606 20.48H17.1406V22.4H15.8606V20.48ZM17.7806 20.48H19.0606V22.4H17.7806V20.48Z"
				fill="#28696D"
			/>
		</svg>
	);
};

export const SettingsIcon = () => {
	return (
		<svg
			width="35"
			height="36"
			viewBox="0 0 35 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect width="35" height="36" rx="17.5" fill="#F5F5F5" />
			<g clipPath="url(#clip0_240_2509)">
				<path
					d="M17.5 20.5C18.8807 20.5 20 19.3807 20 18C20 16.6193 18.8807 15.5 17.5 15.5C16.1193 15.5 15 16.6193 15 18C15 19.3807 16.1193 20.5 17.5 20.5Z"
					stroke="#7C7C7C"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M23.6654 20.5C23.5544 20.7514 23.5213 21.0302 23.5704 21.3005C23.6194 21.5709 23.7483 21.8203 23.9404 22.0167L23.9904 22.0667C24.1453 22.2215 24.2683 22.4053 24.3521 22.6076C24.436 22.81 24.4792 23.0268 24.4792 23.2459C24.4792 23.4649 24.436 23.6818 24.3521 23.8841C24.2683 24.0864 24.1453 24.2703 23.9904 24.425C23.8356 24.58 23.6518 24.7029 23.4494 24.7868C23.2471 24.8707 23.0302 24.9139 22.8112 24.9139C22.5922 24.9139 22.3753 24.8707 22.173 24.7868C21.9706 24.7029 21.7868 24.58 21.632 24.425L21.582 24.375C21.3856 24.1829 21.1362 24.0541 20.8659 24.005C20.5955 23.956 20.3167 23.9891 20.0654 24.1C19.8189 24.2057 19.6087 24.3811 19.4606 24.6047C19.3126 24.8282 19.2331 25.0902 19.232 25.3584V25.5C19.232 25.9421 19.0564 26.366 18.7439 26.6786C18.4313 26.9911 18.0074 27.1667 17.5654 27.1667C17.1233 27.1667 16.6994 26.9911 16.3869 26.6786C16.0743 26.366 15.8987 25.9421 15.8987 25.5V25.425C15.8922 25.1492 15.803 24.8817 15.6425 24.6573C15.482 24.4329 15.2576 24.2619 14.9987 24.1667C14.7474 24.0558 14.4685 24.0227 14.1982 24.0717C13.9279 24.1207 13.6784 24.2496 13.482 24.4417L13.432 24.4917C13.2772 24.6467 13.0934 24.7696 12.8911 24.8535C12.6888 24.9373 12.4719 24.9805 12.2529 24.9805C12.0338 24.9805 11.817 24.9373 11.6146 24.8535C11.4123 24.7696 11.2285 24.6467 11.0737 24.4917C10.9187 24.3369 10.7958 24.1531 10.7119 23.9508C10.6281 23.7484 10.5849 23.5316 10.5849 23.3125C10.5849 23.0935 10.6281 22.8766 10.7119 22.6743C10.7958 22.472 10.9187 22.2882 11.0737 22.1334L11.1237 22.0834C11.3158 21.887 11.4447 21.6375 11.4937 21.3672C11.5427 21.0969 11.5096 20.8181 11.3987 20.5667C11.2931 20.3202 11.1177 20.11 10.8941 19.962C10.6705 19.8139 10.4085 19.7344 10.1404 19.7334H9.9987C9.55667 19.7334 9.13275 19.5578 8.82019 19.2452C8.50763 18.9327 8.33203 18.5087 8.33203 18.0667C8.33203 17.6247 8.50763 17.2008 8.82019 16.8882C9.13275 16.5756 9.55667 16.4 9.9987 16.4H10.0737C10.3495 16.3936 10.617 16.3043 10.8414 16.1438C11.0659 15.9833 11.2368 15.759 11.332 15.5C11.443 15.2487 11.4761 14.9699 11.427 14.6996C11.378 14.4292 11.2491 14.1798 11.057 13.9834L11.007 13.9334C10.8521 13.7786 10.7291 13.5948 10.6453 13.3924C10.5614 13.1901 10.5182 12.9732 10.5182 12.7542C10.5182 12.5352 10.5614 12.3183 10.6453 12.116C10.7291 11.9136 10.8521 11.7298 11.007 11.575C11.1618 11.4201 11.3456 11.2971 11.548 11.2133C11.7503 11.1294 11.9672 11.0862 12.1862 11.0862C12.4052 11.0862 12.6221 11.1294 12.8244 11.2133C13.0268 11.2971 13.2106 11.4201 13.3654 11.575L13.4154 11.625C13.6118 11.8172 13.8612 11.946 14.1315 11.995C14.4019 12.0441 14.6807 12.011 14.932 11.9H14.9987C15.2452 11.7944 15.4554 11.619 15.6034 11.3954C15.7515 11.1719 15.831 10.9099 15.832 10.6417V10.5C15.832 10.058 16.0076 9.63409 16.3202 9.32153C16.6327 9.00897 17.0567 8.83337 17.4987 8.83337C17.9407 8.83337 18.3646 9.00897 18.6772 9.32153C18.9898 9.63409 19.1654 10.058 19.1654 10.5V10.575C19.1664 10.8432 19.2459 11.1052 19.394 11.3288C19.542 11.5523 19.7522 11.7277 19.9987 11.8334C20.25 11.9443 20.5289 11.9774 20.7992 11.9284C21.0695 11.8794 21.319 11.7505 21.5154 11.5584L21.5654 11.5084C21.7202 11.3534 21.904 11.2305 22.1063 11.1466C22.3086 11.0627 22.5255 11.0196 22.7445 11.0196C22.9636 11.0196 23.1804 11.0627 23.3828 11.1466C23.5851 11.2305 23.7689 11.3534 23.9237 11.5084C24.0787 11.6632 24.2016 11.847 24.2855 12.0493C24.3693 12.2516 24.4125 12.4685 24.4125 12.6875C24.4125 12.9066 24.3693 13.1234 24.2855 13.3258C24.2016 13.5281 24.0787 13.7119 23.9237 13.8667L23.8737 13.9167C23.6816 14.1131 23.5527 14.3626 23.5037 14.6329C23.4547 14.9032 23.4878 15.182 23.5987 15.4334V15.5C23.7043 15.7465 23.8797 15.9567 24.1033 16.1048C24.3269 16.2528 24.5889 16.3323 24.857 16.3334H24.9987C25.4407 16.3334 25.8646 16.509 26.1772 16.8215C26.4898 17.1341 26.6654 17.558 26.6654 18C26.6654 18.4421 26.4898 18.866 26.1772 19.1786C25.8646 19.4911 25.4407 19.6667 24.9987 19.6667H24.9237C24.6555 19.6678 24.3936 19.7472 24.17 19.8953C23.9464 20.0434 23.771 20.2536 23.6654 20.5Z"
					stroke="#7C7C7C"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_240_2509">
					<rect
						width="20"
						height="20"
						fill="white"
						transform="translate(7.5 8)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const ArrowRightIcon = () => {
	return (
		<svg
			width="25"
			height="25"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="12.5" cy="12.5" r="12.5" fill="#F4F5F7" />
			<path
				d="M11 17L15 13L11 9"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const ArrowLeftIcon = () => {
	return (
		<svg
			width="25"
			height="25"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle
				cx="12.5"
				cy="12.5"
				r="12.5"
				transform="rotate(-180 12.5 12.5)"
				fill="#F4F5F7"
			/>
			<path
				d="M14 8L10 12L14 16"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const SearchIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.08871 0C11.0017 0 14.1774 3.17574 14.1774 7.08871C14.1774 11.0017 11.0017 14.1774 7.08871 14.1774C3.17574 14.1774 0 11.0017 0 7.08871C0 3.17574 3.17574 0 7.08871 0ZM7.08871 12.6021C10.1345 12.6021 12.6021 10.1345 12.6021 7.08871C12.6021 4.04214 10.1345 1.57527 7.08871 1.57527C4.04214 1.57527 1.57527 4.04214 1.57527 7.08871C1.57527 10.1345 4.04214 12.6021 7.08871 12.6021ZM13.7718 12.6581L16 14.8855L14.8855 16L12.6581 13.7718L13.7718 12.6581Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const RightArrowIcon = () => {
	return (
		<svg
			width="35"
			height="35"
			viewBox="0 0 57 57"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle
				cx="28.5"
				cy="28.5"
				r="28"
				fill="#28696D"
				fillOpacity="0.04"
			/>
			<path
				d="M18 28.5H39"
				stroke="#28696D"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M28.5 18L39 28.5L28.5 39"
				stroke="#28696D"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const LeftArrowIcon = () => {
	return (
		<svg
			width="35"
			height="35"
			viewBox="0 0 57 57"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle
				cx="28.5"
				cy="28.5"
				r="28"
				fill="#28696D"
				fillOpacity="0.04"
			/>
			<path
				d="M18 28.5H39"
				stroke="#28696D"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M28.5 18L39 28.5L28.5 39"
				stroke="#28696D"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
				transform="rotate(180 28.5 28.5)"
			/>
		</svg>
	);
};

export const HelpCircle = () => {
	return (
		<svg
			width="35"
			height="36"
			viewBox="0 0 35 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect width="35" height="36" rx="17.5" fill="#F5F5F5" />
			<path
				d="M17.5 25.5C21.6421 25.5 25 22.1421 25 18C25 13.8579 21.6421 10.5 17.5 10.5C13.3579 10.5 10 13.8579 10 18C10 22.1421 13.3579 25.5 17.5 25.5Z"
				stroke="#7C7C7C"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.3203 15.7499C15.4966 15.2487 15.8447 14.826 16.3028 14.5568C16.7609 14.2876 17.2995 14.1891 17.8232 14.279C18.3469 14.3688 18.8219 14.6411 19.1641 15.0476C19.5063 15.4541 19.6936 15.9686 19.6928 16.4999C19.6928 17.9999 17.4428 18.7499 17.4428 18.7499"
				stroke="#7C7C7C"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5 21.75H17.5083"
				stroke="#7C7C7C"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const TickIcon = () => {
	return (
		<svg
			width="35"
			height="35"
			viewBox="0 0 57 57"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle
				cx="28.5"
				cy="28.5"
				r="28"
				fill="#28696D"
				fillOpacity="0.04"
			/>
			<g clipPath="url(#clip0_1_12592)">
				<path
					d="M41.5 19.5L25 36L17.5 28.5"
					stroke="#28696D"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1_12592">
					<rect
						width="36"
						height="36"
						fill="white"
						transform="translate(10.5 10.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const SmallEyeIcon = props => {
	return (
		<svg
			width="17"
			height="14"
			viewBox="0 0 20 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.9165 8.1C17.8972 3.41 14.0986 0.5 10 0.5C5.90143 0.5 2.10275 3.41 0.0834557 8.1C0.0284116 8.22617 0 8.36234 0 8.5C0 8.63766 0.0284116 8.77383 0.0834557 8.9C2.10275 13.59 5.90143 16.5 10 16.5C14.0986 16.5 17.8972 13.59 19.9165 8.9C19.9716 8.77383 20 8.63766 20 8.5C20 8.36234 19.9716 8.22617 19.9165 8.1ZM10 14.5C6.8311 14.5 3.83215 12.21 2.10275 8.5C3.83215 4.79 6.8311 2.5 10 2.5C13.1689 2.5 16.1679 4.79 17.8972 8.5C16.1679 12.21 13.1689 14.5 10 14.5ZM10 4.5C9.20915 4.5 8.43606 4.7346 7.77849 5.17412C7.12093 5.61365 6.60841 6.23836 6.30577 6.96927C6.00312 7.70017 5.92394 8.50444 6.07823 9.28036C6.23251 10.0563 6.61334 10.769 7.17256 11.3284C7.73177 11.8878 8.44426 12.2688 9.21991 12.4231C9.99556 12.5775 10.7996 12.4983 11.5302 12.1955C12.2609 11.8928 12.8853 11.3801 13.3247 10.7223C13.7641 10.0645 13.9986 9.29113 13.9986 8.5C13.9986 7.43913 13.5773 6.42172 12.8274 5.67157C12.0776 4.92143 11.0605 4.5 10 4.5ZM10 10.5C9.60458 10.5 9.21803 10.3827 8.88925 10.1629C8.56046 9.94318 8.30421 9.63082 8.15288 9.26537C8.00156 8.89991 7.96197 8.49778 8.03911 8.10982C8.11626 7.72186 8.30667 7.36549 8.58628 7.08579C8.86589 6.80608 9.22213 6.6156 9.60996 6.53843C9.99778 6.46126 10.3998 6.50087 10.7651 6.65224C11.1304 6.80362 11.4427 7.05996 11.6624 7.38886C11.882 7.71776 11.9993 8.10444 11.9993 8.5C11.9993 9.03043 11.7887 9.53914 11.4137 9.91421C11.0388 10.2893 10.5302 10.5 10 10.5Z"
				fill={props.error ? 'red' : '#7C7C7C'}
			/>
		</svg>
	);
};

export const MetricIcon = () => {
	return (
		<svg
			width="40"
			height="41"
			viewBox="0 0 40 41"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="20" cy="20.5" r="20" fill="#F3F4F4" />
			<path
				d="M12 24.5a8 8 0 0116 0"
				stroke="#121330"
				strokeWidth="2"
				fill="none"
			/>
			<line
				x1="20"
				y1="20.5"
				x2="26"
				y2="14.5"
				stroke="#121330"
				strokeWidth="2"
			/>
			<circle cx="20" cy="20.5" r="1.5" fill="#121330" />
		</svg>
	);
};

export const FeedbackSideIcon = props => {
	return (
		<svg
			width="26"
			height="26"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				stroke={props.color}
				fill={props.color}
				strokeWidth="0.5"
				d="M 5.003906 1.972656 C 5.082031 1.972656 5.164062 1.972656 5.246094 1.96875 C 5.464844 1.96875 5.683594 1.96875 5.90625 1.96875 C 6.042969 1.96875 6.179688 1.96875 6.316406 1.96875 C 6.796875 1.96875 7.277344 1.96875 7.757812 1.96875 C 8.207031 1.96875 8.652344 1.96875 9.097656 1.96875 C 9.480469 1.964844 9.867188 1.964844 10.25 1.964844 C 10.480469 1.964844 10.710938 1.964844 10.9375 1.964844 C 11.152344 1.964844 11.371094 1.964844 11.585938 1.964844 C 11.703125 1.964844 11.816406 1.964844 11.933594 1.964844 C 12.675781 1.96875 13.226562 2.011719 13.769531 2.546875 C 13.992188 2.796875 14.160156 3.082031 14.160156 3.421875 C 14.234375 3.417969 14.308594 3.417969 14.382812 3.417969 C 15.082031 3.414062 15.78125 3.414062 16.480469 3.410156 C 16.839844 3.410156 17.199219 3.410156 17.558594 3.40625 C 17.90625 3.40625 18.253906 3.402344 18.601562 3.402344 C 18.734375 3.402344 18.867188 3.402344 19 3.402344 C 19.183594 3.398438 19.371094 3.398438 19.554688 3.398438 C 19.609375 3.398438 19.664062 3.398438 19.71875 3.398438 C 20.242188 3.398438 20.628906 3.542969 21.015625 3.902344 C 21.304688 4.230469 21.425781 4.605469 21.429688 5.039062 C 21.429688 5.113281 21.433594 5.1875 21.433594 5.261719 C 21.433594 5.34375 21.433594 5.425781 21.433594 5.503906 C 21.433594 5.546875 21.433594 5.585938 21.433594 5.628906 C 21.4375 5.847656 21.4375 6.0625 21.4375 6.277344 C 21.4375 6.5 21.441406 6.722656 21.441406 6.945312 C 21.445312 7.117188 21.445312 7.289062 21.445312 7.460938 C 21.445312 7.542969 21.445312 7.625 21.445312 7.707031 C 21.453125 8.304688 21.378906 8.703125 21.046875 9.195312 C 20.609375 9.625 20.175781 9.730469 19.578125 9.726562 C 19.527344 9.726562 19.476562 9.726562 19.425781 9.726562 C 19.265625 9.726562 19.105469 9.722656 18.945312 9.722656 C 18.835938 9.722656 18.726562 9.722656 18.617188 9.722656 C 18.351562 9.722656 18.085938 9.722656 17.820312 9.71875 C 17.820312 9.800781 17.820312 9.800781 17.824219 9.878906 C 17.824219 10.078125 17.828125 10.273438 17.828125 10.472656 C 17.832031 10.558594 17.832031 10.644531 17.832031 10.726562 C 17.835938 10.851562 17.835938 10.972656 17.835938 11.097656 C 17.839844 11.207031 17.839844 11.207031 17.839844 11.320312 C 17.816406 11.539062 17.773438 11.648438 17.640625 11.820312 C 17.421875 11.964844 17.359375 11.976562 17.101562 11.941406 C 16.890625 11.835938 16.703125 11.707031 16.507812 11.574219 C 16.453125 11.535156 16.394531 11.5 16.335938 11.460938 C 16.15625 11.339844 15.976562 11.21875 15.796875 11.097656 C 15.675781 11.015625 15.554688 10.9375 15.433594 10.855469 C 15.210938 10.707031 14.988281 10.558594 14.765625 10.40625 C 14.714844 10.375 14.664062 10.339844 14.609375 10.304688 C 14.507812 10.234375 14.40625 10.160156 14.308594 10.082031 C 13.945312 9.800781 13.691406 9.71875 13.230469 9.734375 C 13.144531 9.734375 13.144531 9.734375 13.058594 9.734375 C 12.875 9.734375 12.691406 9.734375 12.511719 9.738281 C 12.328125 9.742188 12.144531 9.742188 11.960938 9.742188 C 11.851562 9.742188 11.738281 9.742188 11.625 9.746094 C 11.082031 9.746094 10.636719 9.582031 10.234375 9.21875 C 10.113281 9.09375 10.007812 8.957031 9.898438 8.820312 C 9.851562 8.851562 9.800781 8.886719 9.75 8.917969 C 9.71875 8.941406 9.6875 8.960938 9.652344 8.984375 C 9.578125 9.035156 9.503906 9.082031 9.433594 9.132812 C 9.226562 9.269531 9.023438 9.402344 8.820312 9.539062 C 8.460938 9.777344 8.101562 10.019531 7.746094 10.257812 C 7.667969 10.308594 7.667969 10.308594 7.59375 10.359375 C 7.503906 10.417969 7.414062 10.480469 7.324219 10.539062 C 7.015625 10.746094 6.859375 10.832031 6.480469 10.800781 C 6.339844 10.6875 6.261719 10.601562 6.179688 10.441406 C 6.175781 10.300781 6.171875 10.160156 6.175781 10.019531 C 6.175781 9.980469 6.175781 9.9375 6.175781 9.898438 C 6.175781 9.765625 6.175781 9.632812 6.175781 9.503906 C 6.175781 9.414062 6.175781 9.324219 6.175781 9.234375 C 6.175781 9.015625 6.179688 8.796875 6.179688 8.578125 C 6.078125 8.582031 6.078125 8.582031 5.972656 8.582031 C 5.71875 8.589844 5.464844 8.589844 5.210938 8.59375 C 5.101562 8.59375 4.992188 8.597656 4.878906 8.597656 C 4.722656 8.601562 4.5625 8.601562 4.40625 8.601562 C 4.332031 8.605469 4.332031 8.605469 4.257812 8.605469 C 3.765625 8.605469 3.332031 8.425781 2.972656 8.085938 C 2.546875 7.597656 2.535156 7.054688 2.539062 6.4375 C 2.539062 6.347656 2.539062 6.253906 2.539062 6.164062 C 2.539062 5.976562 2.539062 5.789062 2.539062 5.597656 C 2.542969 5.359375 2.542969 5.117188 2.539062 4.878906 C 2.539062 4.691406 2.539062 4.503906 2.539062 4.316406 C 2.539062 4.230469 2.539062 4.140625 2.539062 4.050781 C 2.535156 3.460938 2.582031 2.960938 3 2.511719 C 3.582031 1.957031 4.238281 1.972656 5.003906 1.972656 Z M 3.71875 3.179688 C 3.578125 3.390625 3.585938 3.476562 3.582031 3.726562 C 3.582031 3.804688 3.578125 3.878906 3.578125 3.957031 C 3.578125 4.039062 3.578125 4.121094 3.578125 4.203125 C 3.578125 4.289062 3.578125 4.375 3.574219 4.460938 C 3.574219 4.636719 3.574219 4.816406 3.574219 4.996094 C 3.574219 5.222656 3.570312 5.449219 3.570312 5.679688 C 3.566406 5.851562 3.566406 6.027344 3.566406 6.203125 C 3.566406 6.289062 3.566406 6.371094 3.566406 6.457031 C 3.542969 6.964844 3.542969 6.964844 3.714844 7.429688 C 3.980469 7.617188 4.199219 7.609375 4.519531 7.605469 C 4.609375 7.605469 4.609375 7.605469 4.703125 7.605469 C 4.894531 7.605469 5.085938 7.605469 5.277344 7.605469 C 5.46875 7.605469 5.660156 7.605469 5.851562 7.605469 C 5.96875 7.609375 6.085938 7.605469 6.207031 7.605469 C 6.5 7.605469 6.75 7.613281 7.019531 7.738281 C 7.152344 7.941406 7.15625 8.019531 7.164062 8.253906 C 7.167969 8.347656 7.167969 8.347656 7.171875 8.449219 C 7.171875 8.515625 7.175781 8.582031 7.175781 8.652344 C 7.179688 8.753906 7.179688 8.753906 7.183594 8.855469 C 7.191406 9.023438 7.195312 9.191406 7.199219 9.359375 C 7.503906 9.257812 7.75 9.082031 8.011719 8.90625 C 8.058594 8.871094 8.109375 8.839844 8.15625 8.804688 C 8.261719 8.734375 8.363281 8.667969 8.464844 8.597656 C 8.621094 8.488281 8.777344 8.382812 8.933594 8.277344 C 9.035156 8.210938 9.132812 8.144531 9.234375 8.074219 C 9.28125 8.042969 9.328125 8.011719 9.375 7.980469 C 9.441406 7.933594 9.441406 7.933594 9.507812 7.890625 C 9.546875 7.863281 9.582031 7.835938 9.625 7.8125 C 9.730469 7.738281 9.730469 7.738281 9.839844 7.621094 C 9.859375 7.492188 9.859375 7.492188 9.855469 7.347656 C 9.855469 7.289062 9.855469 7.230469 9.855469 7.171875 C 9.855469 7.082031 9.855469 7.082031 9.855469 6.984375 C 9.859375 6.855469 9.859375 6.722656 9.859375 6.59375 C 9.863281 6.386719 9.863281 6.179688 9.863281 5.976562 C 9.863281 5.777344 9.867188 5.578125 9.867188 5.378906 C 9.867188 5.316406 9.867188 5.253906 9.867188 5.191406 C 9.875 4.730469 9.960938 4.308594 10.253906 3.9375 C 10.292969 3.90625 10.328125 3.875 10.367188 3.84375 C 10.40625 3.8125 10.445312 3.78125 10.484375 3.75 C 10.835938 3.523438 11.128906 3.453125 11.539062 3.449219 C 11.585938 3.449219 11.632812 3.445312 11.679688 3.445312 C 11.824219 3.441406 11.972656 3.441406 12.117188 3.4375 C 12.214844 3.4375 12.316406 3.433594 12.414062 3.433594 C 12.65625 3.425781 12.898438 3.421875 13.140625 3.421875 C 13.078125 3.238281 13.027344 3.183594 12.859375 3.082031 C 12.652344 2.996094 12.515625 2.976562 12.292969 2.976562 C 12.222656 2.976562 12.148438 2.976562 12.074219 2.976562 C 11.996094 2.976562 11.917969 2.976562 11.835938 2.976562 C 11.753906 2.976562 11.667969 2.976562 11.585938 2.976562 C 11.359375 2.976562 11.128906 2.976562 10.902344 2.976562 C 10.664062 2.976562 10.425781 2.976562 10.1875 2.976562 C 9.789062 2.976562 9.386719 2.976562 8.988281 2.976562 C 8.523438 2.976562 8.0625 2.976562 7.601562 2.976562 C 7.203125 2.976562 6.804688 2.976562 6.40625 2.976562 C 6.171875 2.976562 5.933594 2.976562 5.695312 2.976562 C 5.472656 2.976562 5.25 2.976562 5.027344 2.976562 C 4.90625 2.976562 4.785156 2.976562 4.664062 2.976562 C 4.59375 2.976562 4.519531 2.976562 4.445312 2.976562 C 4.351562 2.976562 4.351562 2.976562 4.257812 2.976562 C 4.046875 3.003906 3.902344 3.070312 3.71875 3.179688 Z M 10.859375 4.738281 C 10.796875 4.941406 10.792969 5.136719 10.789062 5.347656 C 10.789062 5.40625 10.789062 5.46875 10.789062 5.53125 C 10.789062 5.59375 10.789062 5.65625 10.789062 5.722656 C 10.789062 5.789062 10.789062 5.855469 10.785156 5.925781 C 10.785156 6.066406 10.785156 6.207031 10.785156 6.347656 C 10.785156 6.5625 10.78125 6.777344 10.78125 6.988281 C 10.78125 7.125 10.78125 7.261719 10.78125 7.398438 C 10.78125 7.464844 10.777344 7.527344 10.777344 7.59375 C 10.777344 7.945312 10.789062 8.21875 10.980469 8.519531 C 11.28125 8.746094 11.585938 8.71875 11.945312 8.710938 C 12.066406 8.707031 12.1875 8.707031 12.304688 8.707031 C 12.492188 8.707031 12.679688 8.703125 12.867188 8.699219 C 13.710938 8.679688 14.277344 8.75 14.949219 9.277344 C 15.097656 9.386719 15.25 9.488281 15.40625 9.59375 C 15.589844 9.714844 15.773438 9.839844 15.957031 9.96875 C 16.070312 10.042969 16.183594 10.121094 16.292969 10.199219 C 16.394531 10.269531 16.496094 10.335938 16.59375 10.40625 C 16.71875 10.503906 16.71875 10.503906 16.800781 10.5 C 16.800781 10.457031 16.800781 10.414062 16.800781 10.371094 C 16.804688 10.179688 16.808594 9.988281 16.816406 9.796875 C 16.816406 9.734375 16.816406 9.667969 16.816406 9.597656 C 16.820312 9.535156 16.820312 9.46875 16.824219 9.402344 C 16.824219 9.34375 16.824219 9.285156 16.828125 9.226562 C 16.871094 9 16.921875 8.910156 17.101562 8.761719 C 17.308594 8.714844 17.515625 8.722656 17.726562 8.722656 C 17.820312 8.722656 17.820312 8.722656 17.914062 8.722656 C 18.109375 8.722656 18.304688 8.722656 18.503906 8.722656 C 18.699219 8.722656 18.894531 8.722656 19.089844 8.722656 C 19.210938 8.71875 19.332031 8.71875 19.457031 8.722656 C 19.773438 8.71875 20.007812 8.707031 20.28125 8.519531 C 20.417969 8.3125 20.414062 8.234375 20.417969 7.992188 C 20.417969 7.921875 20.421875 7.851562 20.421875 7.777344 C 20.421875 7.703125 20.421875 7.625 20.421875 7.546875 C 20.421875 7.464844 20.421875 7.386719 20.425781 7.304688 C 20.425781 7.140625 20.425781 6.972656 20.425781 6.804688 C 20.425781 6.589844 20.429688 6.378906 20.429688 6.164062 C 20.433594 5.960938 20.433594 5.753906 20.433594 5.550781 C 20.433594 5.433594 20.433594 5.433594 20.4375 5.316406 C 20.4375 5.246094 20.4375 5.175781 20.4375 5.101562 C 20.4375 5.039062 20.4375 4.976562 20.4375 4.910156 C 20.386719 4.675781 20.285156 4.59375 20.101562 4.441406 C 19.921875 4.394531 19.921875 4.394531 19.726562 4.402344 C 19.652344 4.402344 19.574219 4.398438 19.5 4.398438 C 19.414062 4.398438 19.332031 4.402344 19.25 4.402344 C 19.164062 4.402344 19.074219 4.398438 18.988281 4.398438 C 18.75 4.398438 18.511719 4.398438 18.273438 4.398438 C 18.027344 4.402344 17.777344 4.398438 17.527344 4.398438 C 17.109375 4.398438 16.691406 4.398438 16.273438 4.402344 C 15.792969 4.402344 15.308594 4.402344 14.824219 4.398438 C 14.410156 4.398438 13.996094 4.398438 13.582031 4.398438 C 13.332031 4.398438 13.085938 4.398438 12.839844 4.398438 C 12.605469 4.398438 12.371094 4.398438 12.140625 4.402344 C 12.054688 4.402344 11.96875 4.402344 11.882812 4.398438 C 11.765625 4.398438 11.648438 4.402344 11.535156 4.402344 C 11.46875 4.402344 11.402344 4.402344 11.335938 4.402344 C 11.101562 4.453125 11.011719 4.558594 10.859375 4.738281 Z M 10.859375 4.738281 "
			/>
			<path
				stroke={props.color}
				fill={props.color}
				strokeWidth="0.5"
				d="M 15.4375 17.089844 C 15.53125 17.089844 15.53125 17.089844 15.628906 17.085938 C 15.726562 17.085938 15.726562 17.085938 15.832031 17.085938 C 15.933594 17.085938 15.933594 17.085938 16.042969 17.085938 C 16.1875 17.082031 16.335938 17.082031 16.484375 17.082031 C 16.632812 17.082031 16.785156 17.082031 16.933594 17.078125 C 17.152344 17.074219 17.367188 17.074219 17.585938 17.074219 C 17.683594 17.074219 17.683594 17.074219 17.785156 17.070312 C 18.644531 17.074219 19.398438 17.363281 20.023438 17.953125 C 20.691406 18.65625 20.890625 19.429688 20.890625 20.375 C 20.890625 20.4375 20.894531 20.5 20.894531 20.5625 C 20.894531 20.625 20.894531 20.683594 20.894531 20.746094 C 20.894531 20.800781 20.894531 20.855469 20.894531 20.910156 C 20.878906 21.070312 20.847656 21.164062 20.761719 21.300781 C 20.5625 21.433594 20.5 21.433594 20.269531 21.4375 C 20.207031 21.4375 20.144531 21.4375 20.078125 21.4375 C 20.007812 21.4375 19.9375 21.4375 19.863281 21.4375 C 19.789062 21.4375 19.71875 21.4375 19.640625 21.4375 C 19.4375 21.441406 19.234375 21.441406 19.03125 21.441406 C 18.863281 21.441406 18.695312 21.441406 18.523438 21.441406 C 18.125 21.441406 17.726562 21.441406 17.328125 21.441406 C 16.914062 21.441406 16.503906 21.445312 16.09375 21.445312 C 15.738281 21.445312 15.382812 21.449219 15.03125 21.449219 C 14.820312 21.449219 14.609375 21.449219 14.398438 21.449219 C 14.160156 21.449219 13.925781 21.449219 13.691406 21.449219 C 13.585938 21.449219 13.585938 21.449219 13.480469 21.453125 C 13.007812 21.449219 13.007812 21.449219 12.769531 21.308594 C 12.449219 20.929688 12.574219 20.207031 12.601562 19.738281 C 12.710938 18.902344 13.121094 18.234375 13.765625 17.699219 C 14.269531 17.324219 14.808594 17.097656 15.4375 17.089844 Z M 13.980469 18.898438 C 13.660156 19.429688 13.621094 19.765625 13.621094 20.398438 C 15.679688 20.398438 17.738281 20.398438 19.859375 20.398438 C 19.882812 19.796875 19.882812 19.796875 19.726562 19.292969 C 19.699219 19.238281 19.675781 19.179688 19.648438 19.121094 C 19.496094 18.84375 19.328125 18.644531 19.0625 18.472656 C 19.019531 18.445312 18.976562 18.414062 18.929688 18.386719 C 18.484375 18.132812 18.148438 18.089844 17.636719 18.089844 C 17.53125 18.089844 17.53125 18.089844 17.425781 18.089844 C 17.277344 18.085938 17.128906 18.085938 16.984375 18.085938 C 16.761719 18.085938 16.539062 18.082031 16.316406 18.078125 C 16.171875 18.078125 16.027344 18.078125 15.882812 18.078125 C 15.785156 18.078125 15.785156 18.078125 15.683594 18.074219 C 15.015625 18.082031 14.382812 18.351562 13.980469 18.898438 Z M 13.980469 18.898438 "
			/>
			<path
				stroke={props.color}
				fill={props.color}
				strokeWidth="0.5"
				d="M 7.039062 17.070312 C 7.257812 17.070312 7.480469 17.070312 7.699219 17.066406 C 8.832031 17.066406 9.714844 17.179688 10.578125 17.988281 C 11.226562 18.675781 11.410156 19.457031 11.414062 20.375 C 11.417969 20.457031 11.417969 20.457031 11.417969 20.542969 C 11.421875 21.0625 11.421875 21.0625 11.21875 21.300781 C 11.023438 21.433594 10.960938 21.433594 10.730469 21.4375 C 10.632812 21.4375 10.632812 21.4375 10.535156 21.4375 C 10.464844 21.4375 10.394531 21.4375 10.324219 21.4375 C 10.25 21.4375 10.175781 21.4375 10.101562 21.4375 C 9.898438 21.441406 9.695312 21.441406 9.492188 21.441406 C 9.320312 21.441406 9.152344 21.441406 8.984375 21.441406 C 8.582031 21.441406 8.183594 21.441406 7.785156 21.441406 C 7.371094 21.441406 6.960938 21.445312 6.546875 21.445312 C 6.191406 21.445312 5.839844 21.449219 5.484375 21.449219 C 5.273438 21.449219 5.0625 21.449219 4.851562 21.449219 C 4.617188 21.449219 4.378906 21.449219 4.144531 21.449219 C 4.074219 21.449219 4.003906 21.449219 3.929688 21.453125 C 3.835938 21.449219 3.835938 21.449219 3.738281 21.449219 C 3.679688 21.449219 3.625 21.449219 3.566406 21.449219 C 3.375 21.410156 3.304688 21.328125 3.179688 21.179688 C 2.929688 20.675781 3.074219 19.632812 3.238281 19.113281 C 3.585938 18.246094 4.160156 17.664062 5.003906 17.273438 C 5.660156 17.027344 6.347656 17.0625 7.039062 17.070312 Z M 4.621094 18.78125 C 4.578125 18.824219 4.539062 18.867188 4.496094 18.910156 C 4.15625 19.402344 4.140625 19.777344 4.140625 20.398438 C 6.199219 20.398438 8.257812 20.398438 10.378906 20.398438 C 10.378906 19.625 10.277344 19.175781 9.742188 18.617188 C 9.265625 18.175781 8.777344 18.082031 8.144531 18.082031 C 8.074219 18.082031 8.003906 18.082031 7.933594 18.082031 C 7.785156 18.082031 7.640625 18.082031 7.496094 18.082031 C 7.273438 18.082031 7.050781 18.078125 6.828125 18.078125 C 6.6875 18.078125 6.542969 18.078125 6.398438 18.078125 C 6.300781 18.074219 6.300781 18.074219 6.203125 18.074219 C 5.589844 18.082031 5.015625 18.296875 4.621094 18.78125 Z M 4.621094 18.78125 "
			/>
			<path
				stroke={props.color}
				fill={props.color}
				strokeWidth="0.5"
				d="M 18.078125 12.753906 C 18.488281 13.078125 18.761719 13.535156 18.898438 14.039062 C 18.972656 14.753906 18.890625 15.371094 18.433594 15.953125 C 17.964844 16.445312 17.417969 16.683594 16.742188 16.707031 C 16.132812 16.691406 15.667969 16.46875 15.210938 16.070312 C 14.71875 15.515625 14.546875 15.015625 14.558594 14.273438 C 14.609375 13.742188 14.839844 13.253906 15.238281 12.898438 C 15.414062 12.765625 15.589844 12.648438 15.78125 12.539062 C 15.816406 12.519531 15.851562 12.5 15.886719 12.476562 C 16.589844 12.144531 17.464844 12.339844 18.078125 12.753906 Z M 15.726562 13.878906 C 15.53125 14.171875 15.5625 14.542969 15.601562 14.878906 C 15.714844 15.207031 15.9375 15.441406 16.238281 15.609375 C 16.566406 15.726562 16.914062 15.726562 17.242188 15.609375 C 17.617188 15.398438 17.820312 15.082031 17.941406 14.675781 C 17.941406 14.324219 17.886719 14.007812 17.652344 13.734375 C 17.335938 13.445312 17.066406 13.289062 16.625 13.300781 C 16.230469 13.359375 15.972656 13.578125 15.726562 13.878906 Z M 15.726562 13.878906 "
			/>
			<path
				stroke={props.color}
				fill={props.color}
				strokeWidth="0.5"
				d="M 8.308594 12.570312 C 8.835938 12.878906 9.21875 13.355469 9.390625 13.945312 C 9.519531 14.636719 9.417969 15.269531 9.023438 15.855469 C 8.6875 16.265625 8.207031 16.589844 7.679688 16.679688 C 7.003906 16.746094 6.449219 16.648438 5.890625 16.25 C 5.625 16.027344 5.445312 15.78125 5.28125 15.480469 C 5.257812 15.445312 5.238281 15.410156 5.21875 15.371094 C 5 14.917969 5.03125 14.3125 5.152344 13.835938 C 5.402344 13.1875 5.800781 12.78125 6.421875 12.480469 C 7.03125 12.234375 7.722656 12.289062 8.308594 12.570312 Z M 6.25 13.855469 C 6.09375 14.128906 6.035156 14.414062 6.082031 14.726562 C 6.195312 15.101562 6.375 15.359375 6.695312 15.59375 C 7.042969 15.707031 7.410156 15.734375 7.761719 15.609375 C 8.0625 15.441406 8.285156 15.207031 8.398438 14.878906 C 8.453125 14.496094 8.457031 14.121094 8.21875 13.800781 C 7.933594 13.503906 7.6875 13.339844 7.269531 13.296875 C 6.847656 13.3125 6.511719 13.527344 6.25 13.855469 Z M 6.25 13.855469 "
			/>
		</svg>
	);
};

export const FeedbackTopicIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="20" cy="20" r="20" fill="#F3F4F4" />
			<g clipPath="url(#clip0_489_746)">
				<rect
					x="10"
					y="9.88867"
					width="20"
					height="20"
					fill="url(#pattern0_489_746)"
				/>
			</g>
			<defs>
				<pattern
					id="pattern0_489_746"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1">
					<use
						xlinkHref="#image0_489_746"
						transform="scale(0.0025)"
					/>
				</pattern>
				<clipPath id="clip0_489_746">
					<rect
						width="20"
						height="20"
						fill="white"
						transform="translate(12 10)"
					/>
				</clipPath>
				<image
					id="image0_489_746"
					width="400"
					height="400"
					preserveAspectRatio="none"
					xlinkHref="data:image/png;base64,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"
				/>
			</defs>
		</svg>
	);
};

export const CareNoteIcon = () => {
	return (
		<svg
			width="48"
			height="49"
			viewBox="0 0 48 49"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<mask id="path-1-inside-1_46_2144" fill="white">
				<path d="M34 27.5625C34 28.126 33.552 28.5833 33 28.5833H15C14.448 28.5833 14 28.126 14 27.5625C14 26.999 14.448 26.5417 15 26.5417H33C33.552 26.5417 34 26.999 34 27.5625ZM27 34.7083H15C14.448 34.7083 14 35.1657 14 35.7292C14 36.2927 14.448 36.75 15 36.75H27C27.552 36.75 28 36.2927 28 35.7292C28 35.1657 27.552 34.7083 27 34.7083ZM44 20.386V39.8125C44 44.8779 39.962 49 35 49H13C8.038 49 4 44.8779 4 39.8125V9.1875C4 4.12213 8.038 0 13 0H24.03C27.5 0 30.766 1.38017 33.224 3.88733L40.192 11.0025C42.648 13.5077 44 16.8397 44 20.386ZM31.808 5.32875C30.706 4.20583 29.408 3.37079 28 2.81546V13.2688C28 14.9573 29.346 16.3313 31 16.3313H41.242C40.696 14.894 39.878 13.5669 38.778 12.444L31.808 5.32875ZM42 20.386C42 19.7021 41.924 19.0324 41.808 18.375H31C28.242 18.375 26 16.0843 26 13.2708V2.23767C25.354 2.11925 24.698 2.04167 24.03 2.04167H13C9.14 2.04167 6 5.24708 6 9.1875V39.8125C6 43.7529 9.14 46.9583 13 46.9583H35C38.86 46.9583 42 43.7529 42 39.8125V20.386Z" />
			</mask>
			<path
				d="M34 27.5625C34 28.126 33.552 28.5833 33 28.5833H15C14.448 28.5833 14 28.126 14 27.5625C14 26.999 14.448 26.5417 15 26.5417H33C33.552 26.5417 34 26.999 34 27.5625ZM27 34.7083H15C14.448 34.7083 14 35.1657 14 35.7292C14 36.2927 14.448 36.75 15 36.75H27C27.552 36.75 28 36.2927 28 35.7292C28 35.1657 27.552 34.7083 27 34.7083ZM44 20.386V39.8125C44 44.8779 39.962 49 35 49H13C8.038 49 4 44.8779 4 39.8125V9.1875C4 4.12213 8.038 0 13 0H24.03C27.5 0 30.766 1.38017 33.224 3.88733L40.192 11.0025C42.648 13.5077 44 16.8397 44 20.386ZM31.808 5.32875C30.706 4.20583 29.408 3.37079 28 2.81546V13.2688C28 14.9573 29.346 16.3313 31 16.3313H41.242C40.696 14.894 39.878 13.5669 38.778 12.444L31.808 5.32875ZM42 20.386C42 19.7021 41.924 19.0324 41.808 18.375H31C28.242 18.375 26 16.0843 26 13.2708V2.23767C25.354 2.11925 24.698 2.04167 24.03 2.04167H13C9.14 2.04167 6 5.24708 6 9.1875V39.8125C6 43.7529 9.14 46.9583 13 46.9583H35C38.86 46.9583 42 43.7529 42 39.8125V20.386Z"
				fill="#28696D"
			/>
			<path
				d="M33.224 3.88733L36.7963 0.388946L36.7944 0.386982L33.224 3.88733ZM40.192 11.0025L36.6197 14.5009L36.6216 14.5029L40.192 11.0025ZM31.808 5.32875L35.3798 1.82985L35.3766 1.82661L31.808 5.32875ZM28 2.81546L29.8345 -1.83583L23 -4.53146V2.81546H28ZM41.242 16.3313V21.3313H48.4899L45.9161 14.5557L41.242 16.3313ZM38.778 12.444L35.2062 15.9429L35.2062 15.9429L38.778 12.444ZM41.808 18.375L46.7319 17.5062L46.003 13.375H41.808V18.375ZM26 2.23767H31V-1.92911L26.9015 -2.68039L26 2.23767ZM34 27.5625H29C29 25.4623 30.6939 23.5833 33 23.5833V28.5833V33.5833C36.4101 33.5833 39 30.7897 39 27.5625H34ZM33 28.5833V23.5833H15V28.5833V33.5833H33V28.5833ZM15 28.5833V23.5833C17.3061 23.5833 19 25.4623 19 27.5625H14H9C9 30.7897 11.5899 33.5833 15 33.5833V28.5833ZM14 27.5625H19C19 29.6627 17.3061 31.5417 15 31.5417V26.5417V21.5417C11.5899 21.5417 9 24.3353 9 27.5625H14ZM15 26.5417V31.5417H33V26.5417V21.5417H15V26.5417ZM33 26.5417V31.5417C30.6939 31.5417 29 29.6627 29 27.5625H34H39C39 24.3353 36.4101 21.5417 33 21.5417V26.5417ZM27 34.7083V29.7083H15V34.7083V39.7083H27V34.7083ZM15 34.7083V29.7083C11.5899 29.7083 9 32.5019 9 35.7292H14H19C19 37.8294 17.3061 39.7083 15 39.7083V34.7083ZM14 35.7292H9C9 38.9564 11.5899 41.75 15 41.75V36.75V31.75C17.3061 31.75 19 33.6289 19 35.7292H14ZM15 36.75V41.75H27V36.75V31.75H15V36.75ZM27 36.75V41.75C30.4101 41.75 33 38.9564 33 35.7292H28H23C23 33.6289 24.6939 31.75 27 31.75V36.75ZM28 35.7292H33C33 32.5019 30.4101 29.7083 27 29.7083V34.7083V39.7083C24.6939 39.7083 23 37.8294 23 35.7292H28ZM44 20.386H39V39.8125H44H49V20.386H44ZM44 39.8125H39C39 42.2141 37.1039 44 35 44V49V54C42.8201 54 49 47.5416 49 39.8125H44ZM35 49V44H13V49V54H35V49ZM13 49V44C10.8961 44 9 42.2141 9 39.8125H4H-1C-1 47.5416 5.17988 54 13 54V49ZM4 39.8125H9V9.1875H4H-1V39.8125H4ZM4 9.1875H9C9 6.78586 10.8961 5 13 5V0V-5C5.17988 -5 -1 1.45839 -1 9.1875H4ZM13 0V5H24.03V0V-5H13V0ZM24.03 0V5C26.1401 5 28.1242 5.82771 29.6536 7.38769L33.224 3.88733L36.7944 0.386982C33.4078 -3.06737 28.8599 -5 24.03 -5V0ZM33.224 3.88733L29.6517 7.38572L36.6197 14.5009L40.192 11.0025L43.7643 7.50415L36.7963 0.388946L33.224 3.88733ZM40.192 11.0025L36.6216 14.5029C38.15 16.0618 39 18.1324 39 20.386H44H49C49 15.547 47.146 10.9535 43.7624 7.50219L40.192 11.0025ZM31.808 5.32875L35.3766 1.82661C33.7608 0.180106 31.8638 -1.03546 29.8345 -1.83583L28 2.81546L26.1655 7.46675C26.9522 7.77704 27.6512 8.23156 28.2394 8.83089L31.808 5.32875ZM28 2.81546H23V13.2688H28H33V2.81546H28ZM28 13.2688H23C23 17.621 26.4879 21.3313 31 21.3313V16.3313V11.3313C32.2041 11.3313 33 12.2935 33 13.2688H28ZM31 16.3313V21.3313H41.242V16.3313V11.3313H31V16.3313ZM41.242 16.3313L45.9161 14.5557C45.1433 12.5214 43.9663 10.5952 42.3498 8.94506L38.778 12.444L35.2062 15.9429C35.7897 16.5386 36.2487 17.2665 36.5679 18.1068L41.242 16.3313ZM38.778 12.444L42.3498 8.94506L35.3798 1.82985L31.808 5.32875L28.2362 8.82765L35.2062 15.9429L38.778 12.444ZM42 20.386H47C47 19.3342 46.8832 18.3635 46.7319 17.5062L41.808 18.375L36.8841 19.2438C36.9648 19.7013 37 20.07 37 20.386H42ZM41.808 18.375V13.375H31V18.375V23.375H41.808V18.375ZM31 18.375V13.375C31.0023 13.375 31.0091 13.3753 31.0184 13.3773C31.0274 13.3792 31.035 13.3818 31.0405 13.3841C31.0508 13.3886 31.0478 13.3895 31.038 13.3795C31.0282 13.3695 31.0184 13.3554 31.0116 13.339C31.0061 13.3257 31 13.3054 31 13.2708H26H21C21 18.7467 25.3826 23.375 31 23.375V18.375ZM26 13.2708H31V2.23767H26H21V13.2708H26ZM26 2.23767L26.9015 -2.68039C26.051 -2.83629 25.0821 -2.95833 24.03 -2.95833V2.04167V7.04167C24.3139 7.04167 24.657 7.07479 25.0985 7.15572L26 2.23767ZM24.03 2.04167V-2.95833H13V2.04167V7.04167H24.03V2.04167ZM13 2.04167V-2.95833C6.28188 -2.95833 1 2.58335 1 9.1875H6H11C11 7.91081 11.9981 7.04167 13 7.04167V2.04167ZM6 9.1875H1V39.8125H6H11V9.1875H6ZM6 39.8125H1C1 46.4166 6.28188 51.9583 13 51.9583V46.9583V41.9583C11.9981 41.9583 11 41.0892 11 39.8125H6ZM13 46.9583V51.9583H35V46.9583V41.9583H13V46.9583ZM35 46.9583V51.9583C41.7181 51.9583 47 46.4166 47 39.8125H42H37C37 41.0892 36.0019 41.9583 35 41.9583V46.9583ZM42 39.8125H47V20.386H42H37V39.8125H42Z"
				fill="#28696D"
				mask="url(#path-1-inside-1_46_2144)"
			/>
		</svg>
	);
};

export const ICPIcon = () => {
	return (
		<svg
			width="60"
			height="59"
			viewBox="0 0 60 59"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_48_2173)">
				<path
					d="M58.667 0.5H0.666992V58.5H58.667V0.5Z"
					fill="url(#pattern0_48_2173)"
				/>
			</g>
			<defs>
				<pattern
					id="pattern0_48_2173"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1">
					<use
						xlinkHref="#image0_48_2173"
						transform="scale(0.0025)"
					/>
				</pattern>
				<clipPath id="clip0_48_2173">
					<rect
						width="59"
						height="59"
						fill="white"
						transform="translate(0.333496)"
					/>
				</clipPath>
				<image
					id="image0_48_2173"
					width="400"
					height="400"
					preserveAspectRatio="none"
					xlinkHref="data:image/png;base64,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"
				/>
			</defs>
		</svg>
	);
};

export const OCPIcon = () => {
	return (
		<svg
			width="51"
			height="51"
			viewBox="0 0 51 51"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_46_2168)">
				<path
					d="M42.4999 18.4021C40.7582 16.5563 38.4624 15.4521 36.0832 15.1875V10.9167C36.0832 5.17292 31.4103 0.5 25.6665 0.5C19.9228 0.5 15.2499 5.17292 15.2499 10.9167V15.1854C12.8353 15.4521 10.5082 16.5917 8.76237 18.4896C6.7457 20.6813 5.70404 23.5583 5.90612 26.3813C6.44362 33.8917 13.5832 42.4875 20.4207 47.675C21.927 48.8167 23.7894 49.45 25.6644 49.4563H25.6936C27.5624 49.4563 29.3332 48.8604 30.8165 47.7333C37.554 42.6083 45.0061 33.6813 45.4415 26.1979C45.604 23.3938 44.5332 20.5521 42.504 18.4L42.4999 18.4021ZM25.6665 2.58333C30.2624 2.58333 33.9999 6.32083 33.9999 10.9167V15.1479C30.402 15.5042 27.2124 17.65 25.6478 20.5396C25.1936 19.7125 24.5999 18.925 23.8853 18.2188C22.1165 16.4708 19.7353 15.4125 17.3311 15.175V10.9167C17.3311 6.32083 21.0686 2.58333 25.6644 2.58333H25.6665ZM29.552 46.0771C28.4353 46.925 27.0999 47.375 25.6895 47.375H25.6686C24.2415 47.3708 22.8249 46.8896 21.6749 46.0167C15.4228 41.2729 8.46862 33.0583 7.9832 26.2333C7.82279 23.9792 8.66445 21.6729 10.2936 19.9C11.8728 18.1833 14.0207 17.1833 16.1853 17.1563C16.2061 17.1563 16.2249 17.1563 16.2457 17.1563C16.2603 17.1563 16.2728 17.1646 16.2895 17.1646C16.2999 17.1646 16.3082 17.1583 16.3186 17.1583C18.5707 17.1667 20.7895 18.0875 22.4207 19.6979C23.8207 21.0813 24.6249 22.8146 24.6249 24.4563C24.6249 25.0313 25.0915 25.4979 25.6665 25.4979C26.2415 25.4979 26.7082 25.0313 26.7082 24.4563C26.7082 21.0167 30.2582 17.175 35.0103 17.1583C35.0207 17.1583 35.029 17.1646 35.0415 17.1646C35.052 17.1646 35.0603 17.1583 35.0707 17.1583C37.2332 17.1667 39.3874 18.1375 40.9853 19.8292C42.6228 21.5646 43.4874 23.8417 43.3582 26.0771C42.9603 32.9042 35.9228 41.2292 29.552 46.0771ZM26.7082 32.7917V36.9583C26.7082 37.5333 26.2415 38 25.6665 38C25.0915 38 24.6249 37.5333 24.6249 36.9583V32.7917C24.6249 32.2167 25.0915 31.75 25.6665 31.75C26.2415 31.75 26.7082 32.2167 26.7082 32.7917Z"
					fill="#28696D"
				/>
			</g>
			<defs>
				<clipPath id="clip0_46_2168">
					<rect
						width="50"
						height="50"
						fill="white"
						transform="translate(0.666504 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const PlanPerIcon = () => {
	return (
		<svg
			width="60"
			height="61"
			viewBox="0 0 60 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_46_2158)">
				<path
					d="M60 0.5H0V60.5H60V0.5Z"
					fill="url(#pattern0_46_2158)"
				/>
			</g>
			<defs>
				<pattern
					id="pattern0_46_2158"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1">
					<use
						xlinkHref="#image0_46_2158"
						transform="scale(0.0025)"
					/>
				</pattern>
				<clipPath id="clip0_46_2158">
					<rect
						width="60"
						height="60"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
				<image
					id="image0_46_2158"
					width="400"
					height="400"
					preserveAspectRatio="none"
					xlinkHref="data:image/png;base64,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"
				/>
			</defs>
		</svg>
	);
};

export const ViewELIcon = ({ color = '#324054' }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_138_8232)">
				<path
					d="M0.666992 7.99935C0.666992 7.99935 3.33366 2.66602 8.00033 2.66602C12.667 2.66602 15.3337 7.99935 15.3337 7.99935C15.3337 7.99935 12.667 13.3327 8.00033 13.3327C3.33366 13.3327 0.666992 7.99935 0.666992 7.99935Z"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_138_8232">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const EditELIcon = ({ color = '#324054' }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_138_8235)">
				<path
					d="M7.33301 2.66602H2.66634C2.31272 2.66602 1.97358 2.80649 1.72353 3.05654C1.47348 3.30659 1.33301 3.64573 1.33301 3.99935V13.3327C1.33301 13.6863 1.47348 14.0254 1.72353 14.2755C1.97358 14.5255 2.31272 14.666 2.66634 14.666H11.9997C12.3533 14.666 12.6924 14.5255 12.9425 14.2755C13.1925 14.0254 13.333 13.6863 13.333 13.3327V8.66602"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.333 1.66617C12.5982 1.40095 12.9579 1.25195 13.333 1.25195C13.7081 1.25195 14.0678 1.40095 14.333 1.66617C14.5982 1.93138 14.7472 2.29109 14.7472 2.66617C14.7472 3.04124 14.5982 3.40095 14.333 3.66617L7.99967 9.9995L5.33301 10.6662L5.99967 7.9995L12.333 1.66617Z"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_138_8235">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const DeleteELIcon = ({ color = '#FF4343' }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M2 4H3.33333H14"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.6663 4.00065V13.334C12.6663 13.6876 12.5259 14.0267 12.2758 14.2768C12.0258 14.5268 11.6866 14.6673 11.333 14.6673H4.66634C4.31272 14.6673 3.97358 14.5268 3.72353 14.2768C3.47348 14.0267 3.33301 13.6876 3.33301 13.334V4.00065M5.33301 4.00065V2.66732C5.33301 2.3137 5.47348 1.97456 5.72353 1.72451C5.97358 1.47446 6.31272 1.33398 6.66634 1.33398H9.33301C9.68663 1.33398 10.0258 1.47446 10.2758 1.72451C10.5259 1.97456 10.6663 2.3137 10.6663 2.66732V4.00065"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66699 7.33398V11.334"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33301 7.33398V11.334"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const OCPDataIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="40" rx="20" fill="#EBFAF8" />
			<g clipPath="url(#clip0_231_2894)">
				<path
					d="M20.0007 26.6663C23.6825 26.6663 26.6673 23.6816 26.6673 19.9997C26.6673 16.3178 23.6825 13.333 20.0007 13.333C16.3188 13.333 13.334 16.3178 13.334 19.9997C13.334 23.6816 16.3188 26.6663 20.0007 26.6663Z"
					stroke="#28696D"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M26.6667 20H24"
					stroke="#28696D"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.9997 20H13.333"
					stroke="#28696D"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M20 15.9997V13.333"
					stroke="#28696D"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M20 26.6667V24"
					stroke="#28696D"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_231_2894">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(12 12)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const ICPDataIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="40" rx="20" fill="#EBFAF8" />
			<g transform="translate(10, 10)">
				<path
					d="M14.75 2.25H4.25C3.42157 2.25 2.75 2.92157 2.75 3.75V14.25C2.75 15.0784 3.42157 15.75 4.25 15.75H14.75C15.5784 15.75 16.25 15.0784 16.25 14.25V3.75C16.25 2.92157 15.5784 2.25 14.75 2.25Z"
					stroke="#28696D"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2.75 6.75H16.25"
					stroke="#28696D"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.25 15.75V6.75"
					stroke="#28696D"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
};

export const CNDataIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="40" rx="20" fill="#EBFAF8" />
			<g transform="translate(10, 10)">
				<path
					d="M15.5 5.25H3.5C2.67157 5.25 2 5.92157 2 6.75V14.25C2 15.0784 2.67157 15.75 3.5 15.75H15.5C16.3284 15.75 17 15.0784 17 14.25V6.75C17 5.92157 16.3284 5.25 15.5 5.25Z"
					stroke="#28696D"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.5 15.75V3.75C12.5 3.35218 12.342 2.97064 12.0607 2.68934C11.7794 2.40804 11.3978 2.25 11 2.25H8C7.60218 2.25 7.22064 2.40804 6.93934 2.68934C6.65804 2.97064 6.5 3.35218 6.5 3.75V15.75"
					stroke="#28696D"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
};

export const UserCheck = () => {
	return (
		<svg
			width="15"
			height="14"
			viewBox="0 0 15 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_9_335)">
				<path
					d="M9.83301 12.25V11.0833C9.83301 10.4645 9.58717 9.871 9.14959 9.43342C8.71201 8.99583 8.11851 8.75 7.49967 8.75H3.41634C2.7975 8.75 2.20401 8.99583 1.76643 9.43342C1.32884 9.871 1.08301 10.4645 1.08301 11.0833V12.25"
					stroke="#3D4A58"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5.45833 6.41667C6.747 6.41667 7.79167 5.372 7.79167 4.08333C7.79167 2.79467 6.747 1.75 5.45833 1.75C4.16967 1.75 3.125 2.79467 3.125 4.08333C3.125 5.372 4.16967 6.41667 5.45833 6.41667Z"
					stroke="#3D4A58"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.417 6.41667L11.5837 7.58333L13.917 5.25"
					stroke="#3D4A58"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_9_335">
					<rect
						width="14"
						height="14"
						fill="white"
						transform="translate(0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const UserDataIcon = () => {
	return (
		<svg
			width="15"
			height="14"
			viewBox="0 0 15 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.1663 12.25V11.0833C12.1663 10.4645 11.9205 9.871 11.4829 9.43342C11.0453 8.99583 10.4518 8.75 9.83301 8.75H5.16634C4.5475 8.75 3.95401 8.99583 3.51643 9.43342C3.07884 9.871 2.83301 10.4645 2.83301 11.0833V12.25"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.50033 6.41667C8.78899 6.41667 9.83366 5.372 9.83366 4.08333C9.83366 2.79467 8.78899 1.75 7.50033 1.75C6.21166 1.75 5.16699 2.79467 5.16699 4.08333C5.16699 5.372 6.21166 6.41667 7.50033 6.41667Z"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const CalenderIcon = () => {
	return (
		<svg
			width="21"
			height="20"
			viewBox="0 0 21 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.3333 3.33301H4.66667C3.74619 3.33301 3 4.0792 3 4.99967V16.6663C3 17.5868 3.74619 18.333 4.66667 18.333H16.3333C17.2538 18.333 18 17.5868 18 16.6663V4.99967C18 4.0792 17.2538 3.33301 16.3333 3.33301Z"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8335 1.66699V5.00033"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.1665 1.66699V5.00033"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 8.33301H18"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const leftArrow = () => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M25.3337 16H6.66699"
				stroke="#324054"
				strokeWidth="2.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.0003 25.3337L6.66699 16.0003L16.0003 6.66699"
				stroke="#324054"
				strokeWidth="2.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const FileIcon = () => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.6663 3H7.99967C7.29243 3 6.61415 3.28095 6.11406 3.78105C5.61396 4.28115 5.33301 4.95942 5.33301 5.66667V27C5.33301 27.7072 5.61396 28.3855 6.11406 28.8856C6.61415 29.3857 7.29243 29.6667 7.99967 29.6667H23.9997C24.7069 29.6667 25.3852 29.3857 25.8853 28.8856C26.3854 28.3855 26.6663 27.7072 26.6663 27V11L18.6663 3Z"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 3V11H26"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.3337 17.666H10.667"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.3337 23H10.667"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.3337 12H10.667"
				stroke="#28696D"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const DownloadSmallIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
				stroke="#7C7C7C"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.66699 6.66699L8.00033 10.0003L11.3337 6.66699"
				stroke="#7C7C7C"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 10V2"
				stroke="#7C7C7C"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const REOViewIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="20" cy="20" r="20" fill="white" />
			<rect
				width="20"
				height="20"
				transform="translate(10 11.1113)"
				fill="white"
			/>
			<g clipPath="url(#clip0_390_2807)">
				<path
					d="M24.667 26V24.6667C24.667 23.9594 24.386 23.2811 23.8859 22.781C23.3858 22.281 22.7076 22 22.0003 22H17.3337C16.6264 22 15.9481 22.281 15.448 22.781C14.9479 23.2811 14.667 23.9594 14.667 24.6667V26"
					stroke="#324054"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M19.6667 19.3333C21.1394 19.3333 22.3333 18.1394 22.3333 16.6667C22.3333 15.1939 21.1394 14 19.6667 14C18.1939 14 17 15.1939 17 16.6667C17 18.1394 18.1939 19.3333 19.6667 19.3333Z"
					stroke="#324054"
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_390_2807">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(14 12)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const SummarizerIcon = props => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 17 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.83268 1.83301H4.49935C4.14573 1.83301 3.80659 1.97348 3.55654 2.22353C3.30649 2.47358 3.16602 2.81272 3.16602 3.16634V13.833C3.16602 14.1866 3.30649 14.5258 3.55654 14.7758C3.80659 15.0259 4.14573 15.1663 4.49935 15.1663H12.4993C12.853 15.1663 13.1921 15.0259 13.4422 14.7758C13.6922 14.5258 13.8327 14.1866 13.8327 13.833V5.83301L9.83268 1.83301Z"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.83398 1.83301V5.83301H13.834"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.1673 9.16699H5.83398"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.1673 11.833H5.83398"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.16732 6.5H6.50065H5.83398"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const SmallFileIcon = props => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 14 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.33268 1.5H3.99935C3.64573 1.5 3.30659 1.64048 3.05654 1.89052C2.80649 2.14057 2.66602 2.47971 2.66602 2.83333V13.5C2.66602 13.8536 2.80649 14.1928 3.05654 14.4428C3.30659 14.6929 3.64573 14.8333 3.99935 14.8333H11.9993C12.353 14.8333 12.6921 14.6929 12.9422 14.4428C13.1922 14.1928 13.3327 13.8536 13.3327 13.5V5.5L9.33268 1.5Z"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 1.5V5.5H13"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.6673 8.83203H5.33398"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.6673 11.5H5.33398"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66634 6H5.33301"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const RedTrashIcon = () => {
	return (
		<svg
			width="17"
			height="16"
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M2.5 4H3.83333H14.5"
				stroke="#FF4343"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.1663 3.99967V13.333C13.1663 13.6866 13.0259 14.0258 12.7758 14.2758C12.5258 14.5259 12.1866 14.6663 11.833 14.6663H5.16634C4.81272 14.6663 4.47358 14.5259 4.22353 14.2758C3.97348 14.0258 3.83301 13.6866 3.83301 13.333V3.99967M5.83301 3.99967V2.66634C5.83301 2.31272 5.97348 1.97358 6.22353 1.72353C6.47358 1.47348 6.81272 1.33301 7.16634 1.33301H9.83301C10.1866 1.33301 10.5258 1.47348 10.7758 1.72353C11.0259 1.97358 11.1663 2.31272 11.1663 2.66634V3.99967"
				stroke="#FF4343"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.16699 7.33301V11.333"
				stroke="#FF4343"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.83301 7.33301V11.333"
				stroke="#FF4343"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const BigFileIcon = () => {
	return (
		<svg
			width="54"
			height="51"
			viewBox="0 0 54 51"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<ellipse cx="27" cy="25.5" rx="27" ry="25.5" fill="white" />
			<g clipPath="url(#clip0_492_8383)">
				<path
					d="M30.0173 12.709H20.9644C20.3642 12.709 19.7885 12.9441 19.3641 13.3625C18.9396 13.7809 18.7012 14.3485 18.7012 14.9402V32.7902C18.7012 33.382 18.9396 33.9495 19.3641 34.368C19.7885 34.7864 20.3642 35.0215 20.9644 35.0215H34.5438C35.1441 35.0215 35.7197 34.7864 36.1442 34.368C36.5686 33.9495 36.8071 33.382 36.8071 32.7902V19.4027L30.0173 12.709Z"
					stroke="#324054"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M29.4512 12.709V19.4027H36.2409"
					stroke="#324054"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M32.2805 24.9805H23.2275"
					stroke="#324054"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M32.2805 29.4434H23.2275"
					stroke="#324054"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M25.4908 20.2402H23.2275"
					stroke="#324054"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_492_8383">
					<rect
						width="25.65"
						height="26.775"
						fill="white"
						transform="translate(16.875 10.1992)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const EditWhiteIcon = () => {
	return (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.33301 3.16699H2.66634C2.31272 3.16699 1.97358 3.30747 1.72353 3.55752C1.47348 3.80756 1.33301 4.1467 1.33301 4.50033V13.8337C1.33301 14.1873 1.47348 14.5264 1.72353 14.7765C1.97358 15.0265 2.31272 15.167 2.66634 15.167H11.9997C12.3533 15.167 12.6924 15.0265 12.9425 14.7765C13.1925 14.5264 13.333 14.1873 13.333 13.8337V9.16699"
				stroke="white"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.333 2.16714C12.5982 1.90193 12.9579 1.75293 13.333 1.75293C13.7081 1.75293 14.0678 1.90193 14.333 2.16714C14.5982 2.43236 14.7472 2.79207 14.7472 3.16714C14.7472 3.54222 14.5982 3.90193 14.333 4.16714L7.99967 10.5005L5.33301 11.1671L5.99967 8.50048L12.333 2.16714Z"
				stroke="white"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const ViewWhiteIcon = () => {
	return (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_492_8960)">
				<path
					d="M0.666992 8.49935C0.666992 8.49935 3.33366 3.16602 8.00033 3.16602C12.667 3.16602 15.3337 8.49935 15.3337 8.49935C15.3337 8.49935 12.667 13.8327 8.00033 13.8327C3.33366 13.8327 0.666992 8.49935 0.666992 8.49935Z"
					stroke="white"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z"
					stroke="white"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_492_8960">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const APIIcon = props => {
	return (
		<svg
			width="22"
			height="22"
			viewBox="0 0 17 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.5 14.5C13.6046 14.5 14.5 13.6046 14.5 12.5C14.5 11.3954 13.6046 10.5 12.5 10.5C11.3954 10.5 10.5 11.3954 10.5 12.5C10.5 13.6046 11.3954 14.5 12.5 14.5Z"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.5 6.5C5.60457 6.5 6.5 5.60457 6.5 4.5C6.5 3.39543 5.60457 2.5 4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5C2.5 5.60457 3.39543 6.5 4.5 6.5Z"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.16669 4.5H11.1667C11.5203 4.5 11.8594 4.64048 12.1095 4.89052C12.3595 5.14057 12.5 5.47971 12.5 5.83333V10.5"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.5 6.5V14.5"
				stroke={props.color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const UploadSmIcon = () => {
	return (
		<svg
			width="17"
			height="16"
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_910_300)">
				<path
					d="M8.5 8V14"
					stroke="white"
					strokeWidth="1.3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.0933 12.26C14.7436 11.9055 15.2572 11.3446 15.5533 10.6658C15.8493 9.98692 15.9108 9.22883 15.7281 8.51114C15.5455 7.79344 15.129 7.15702 14.5445 6.70231C13.9599 6.2476 13.2406 6.0005 12.5 6.00001H11.66C11.4582 5.2195 11.0821 4.4949 10.56 3.88067C10.0378 3.26644 9.38323 2.77858 8.6454 2.45375C7.90757 2.12892 7.1057 1.97558 6.30008 2.00526C5.49446 2.03495 4.70605 2.24688 3.99412 2.62512C3.2822 3.00336 2.66528 3.53808 2.18975 4.18906C1.71423 4.84005 1.39246 5.59037 1.24866 6.38361C1.10485 7.17684 1.14274 7.99236 1.35948 8.76885C1.57622 9.54534 1.96617 10.2626 2.5 10.8667"
					stroke="white"
					strokeWidth="1.3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11.1667 10.6667L9.83334 9.33333L8.50001 8L5.83334 10.6667"
					stroke="white"
					strokeWidth="1.3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_910_300">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export function SmallWIcon() {
	return (
		<svg
			width="21"
			height="20"
			viewBox="0 0 21 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.5 18.3334C15.1024 18.3334 18.8334 14.6024 18.8334 10C18.8334 5.39765 15.1024 1.66669 10.5 1.66669C5.89765 1.66669 2.16669 5.39765 2.16669 10C2.16669 14.6024 5.89765 18.3334 10.5 18.3334Z"
				stroke="#191919"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5 13.3333V10"
				stroke="#191919"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5 6.66669H10.5083"
				stroke="#191919"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export const LayoutListIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="#FFFFFF"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<rect x="3" y="3" width="7" height="7"></rect>
			<rect x="14" y="3" width="7" height="7"></rect>
			<rect x="14" y="14" width="7" height="7"></rect>
			<rect x="3" y="14" width="7" height="7"></rect>
		</svg>
	);
};

export const CheckSquareIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="#FFFFFF"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<polyline points="9 11 12 14 22 4"></polyline>
			<path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
		</svg>
	);
};

export const CareNoteSmallIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="20" cy="20" r="20" fill="white" />
			<g transform="translate(13 10) scale(0.4)">
				<mask id="path-1-inside-1_46_2144" fill="white">
					<path d="M34 27.5625C34 28.126 33.552 28.5833 33 28.5833H15C14.448 28.5833 14 28.126 14 27.5625C14 26.999 14.448 26.5417 15 26.5417H33C33.552 26.5417 34 26.999 34 27.5625ZM27 34.7083H15C14.448 34.7083 14 35.1657 14 35.7292C14 36.2927 14.448 36.75 15 36.75H27C27.552 36.75 28 36.2927 28 35.7292C28 35.1657 27.552 34.7083 27 34.7083ZM44 20.386V39.8125C44 44.8779 39.962 49 35 49H13C8.038 49 4 44.8779 4 39.8125V9.1875C4 4.12213 8.038 0 13 0H24.03C27.5 0 30.766 1.38017 33.224 3.88733L40.192 11.0025C42.648 13.5077 44 16.8397 44 20.386ZM31.808 5.32875C30.706 4.20583 29.408 3.37079 28 2.81546V13.2688C28 14.9573 29.346 16.3313 31 16.3313H41.242C40.696 14.894 39.878 13.5669 38.778 12.444L31.808 5.32875ZM42 20.386C42 19.7021 41.924 19.0324 41.808 18.375H31C28.242 18.375 26 16.0843 26 13.2708V2.23767C25.354 2.11925 24.698 2.04167 24.03 2.04167H13C9.14 2.04167 6 5.24708 6 9.1875V39.8125C6 43.7529 9.14 46.9583 13 46.9583H35C38.86 46.9583 42 43.7529 42 39.8125V20.386Z" />
				</mask>
				<path
					d="M34 27.5625C34 28.126 33.552 28.5833 33 28.5833H15C14.448 28.5833 14 28.126 14 27.5625C14 26.999 14.448 26.5417 15 26.5417H33C33.552 26.5417 34 26.999 34 27.5625ZM27 34.7083H15C14.448 34.7083 14 35.1657 14 35.7292C14 36.2927 14.448 36.75 15 36.75H27C27.552 36.75 28 36.2927 28 35.7292C28 35.1657 27.552 34.7083 27 34.7083ZM44 20.386V39.8125C44 44.8779 39.962 49 35 49H13C8.038 49 4 44.8779 4 39.8125V9.1875C4 4.12213 8.038 0 13 0H24.03C27.5 0 30.766 1.38017 33.224 3.88733L40.192 11.0025C42.648 13.5077 44 16.8397 44 20.386ZM31.808 5.32875C30.706 4.20583 29.408 3.37079 28 2.81546V13.2688C28 14.9573 29.346 16.3313 31 16.3313H41.242C40.696 14.894 39.878 13.5669 38.778 12.444L31.808 5.32875ZM42 20.386C42 19.7021 41.924 19.0324 41.808 18.375H31C28.242 18.375 26 16.0843 26 13.2708V2.23767C25.354 2.11925 24.698 2.04167 24.03 2.04167H13C9.14 2.04167 6 5.24708 6 9.1875V39.8125C6 43.7529 9.14 46.9583 13 46.9583H35C38.86 46.9583 42 43.7529 42 39.8125V20.386Z"
					stroke="#324054"
					strokeWidth="2"
				/>
			</g>
		</svg>
	);
};

export const NotificationIcon = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 -960 960 960"
			width="24px"
			fill={props.color}>
			<path d="M720-160v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-600 40q-33 0-56.5-23.5T40-200v-560q0-33 23.5-56.5T120-840h560q33 0 56.5 23.5T760-760v200h-80v-80H120v440h520v80H120Zm0-600h560v-40H120v40Zm0 0v-40 40Z" />
		</svg>
	);
};
